var quoteResultsStartDate = $('.quote__option-wrapper.active .quote__option-period .start-date').val(),
quoteResultsValidateStartDate = true,
yourPolicyQuoteStartDateUpdated = false;

// function to defer current AJAX request by 600 milliseconds.
function wait() {
	var deferred = jQuery.Deferred();
	setTimeout(function () {
		deferred.resolve();
	}, 600);

	return deferred.promise();
}

// function to calculate the current scroll progress for the bar.
function calculateProgressBar() {
	if ($(".g__header__bar-item.current").length) {
		let winScroll = $(window).scrollTop();
		let height = $(document).height() - window.innerHeight;
		let scrolled = (winScroll / height) * 100;
		$(".g__header__bar-item.current .g__header__bar-item__bar-fill").css("width", "calc(" + scrolled + "% - 90px)");
	}
}

function parseUKDate(dateString) {
    if (!dateString) return null;

    // ISO format (e.g. 2026-03-24T13:17)
    if (dateString.includes('-')) {
        let date = new Date(dateString);
        return isNaN(date.getTime()) ? null : date;
    }

    // UK format (dd/mm/yyyy or mm/yyyy)
    if (dateString.includes('/')) {
        let parts = dateString.split('/');
        let day = 1, month, year;

        if (parts.length === 3) {
            day = parseInt(parts[0], 10);
            month = parseInt(parts[1], 10) - 1;
            year = parseInt(parts[2], 10);
        } else if (parts.length === 2) {
            month = parseInt(parts[0], 10) - 1;
            year = parseInt(parts[1], 10);
        } else {
            return null;
        }

        let date = new Date(year, month, day);

        if (
            date.getFullYear() !== year ||
            date.getMonth() !== month ||
            (parts.length === 3 && date.getDate() !== day)
        ) {
            return null;
        }

        return date;
    }

    return null;
}

// function to toggle the boolean questions yes/no.
function addButtonEvents(parent) {
	let target = parent.find(".quote-question__boolean-btn:not(.readonly)");

	if (target.length) {
		$(target).on("click", target, function (e) {
			e.preventDefault();

			$(this).siblings(".quote-question__boolean-btn.active:not(.readonly)").removeClass("active");
			$(this).addClass("active");

			if ($(this).data("target")) {
				let target = "#" + $(this).data("target");
				$(target).prop("checked", true).trigger("change");
			}
		});
	}

	let disabledTarget = parent.find(".quote-question__boolean-btn.readonly");

	if (disabledTarget.length) {
		$(disabledTarget).on("click", function (e) {
			e.preventDefault();
		});
	}
}

// function to initialise select2 improved Dropdowns.
function addSelect2(parent) {
	let target = parent.find(".quote-question__dropdown");

	if (target.length) {
		$(target).each(function () {
			var selectTarget = $(this).find("select");
			var parent = selectTarget.closest(".quote-question");

			if (selectTarget.length) {
				if(parent.data("enable-quick-access") != true) {
					// if it's not months/years dropdowns, then allow search for 7 min options.
					if (!parent.hasClass("quote-question__month-year")) {
						selectTarget.select2({
							minimumResultsForSearch: 12,
						});
					} else {
						selectTarget.select2({
							minimumResultsForSearch: -1,
						});
					}
				}
			}
		});
	}
}

// function to initialise flatpickr for DatePicker.
function addDatePicker(parent) {
	let target = parent.find(".quote-question__date");

	if (target.length) {
		$(target).each(function () {
			let input = $(this).find("input");
			let customDateFormat = input.data("format") ? input.data("format").toString() : "Y-m-dTH:i:S";
			let enableHours = input.data("hour");
			let minDate = input.data("min");
			let maxDate = input.data("max");

			let config = {
				dateFormat: "Y-m-dTH:i:S",
				altFormat: customDateFormat,
				altInput: true,
			};

			if (maxDate) {
				config.maxDate = maxDate;
			}

			if (minDate) {
				config.minDate = minDate;
			}

			if (enableHours) {
				config.enableHours = enableHours;
				config.enableTime = true;
			}

			flatpickr(input, config);
		});
	}
}

function triggerDefaultDatePicker() {
	var policyDates = document.querySelectorAll(".quote-question__date:not(.quote-question__dob)"),
		quoteDates = document.querySelectorAll(".quote-question__date-time"),
		dobDates = document.querySelectorAll(".quote-question__dob:not(.quote-question__date)"),
		parents = [...policyDates, ...quoteDates, ...dobDates];

	parents.forEach(function (item) {
		var svg = item.querySelector("svg"),
			dateInput = item.querySelector("input");

		if (svg !== undefined && svg !== null) {
			svg.addEventListener("click", async () => {
				try {
					await dateInput.showPicker();
					await dateInput.focus();

					dateInput.addEventListener("input", function (event) {
						dateInput.blur();
					});
					// A date picker is shown.
				} catch (error) {
					// Use external library when this fails.
				}
			});
		}
	});
}

// function to toggle On/Off question sub children
function toggleQuestionChildren(parent) {
	let target = parent.find(".quote-question--parent");
	if (target.length) {
		target.each(function () {
			let any_values = $(this).closest(".quote-question").data("any-toggle") ? $(this).closest(".quote-question").data("any-toggle") : false;
			let is_checkbox = false;

			if (any_values == true) {
				let input = $(this).closest(".quote-question").find('input[type="radio"]').length
					? $(this).closest(".quote-question").find('input[type="radio"]')
					: $(this).closest(".quote-question").find("select.quote-question--select");

				if (!input.length) {
					input = $(this).closest(".quote-question").find('input[type="checkbox"]');
					is_checkbox = true;
				}

				input.change(function () {
					if (is_checkbox) {
						let target = $(this).closest(".quote-question").data("target-children") ? "#" + $(this).closest(".quote-question").data("target-children").toString() : "";
						let targetParent = $(target).parent(".quote-question--children-wrapper");
						let currentElement = $(target);
						let removeElement = currentElement.siblings(".quote-question__multiple-remove");

						if (this.checked) {
							currentElement.addClass("active");
							currentElement.children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);

							// loop through all the cloned children and enable them all.
							while (currentElement.next().hasClass("quote-question--children")) {
								if (!currentElement.next().hasClass("c__loader--wrapper")) {
									currentElement.next().addClass("active");
									currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);
								}

								currentElement = currentElement.next();
							}

							if (currentElement.siblings(".quote-question__multiple-toggle").length) {
								currentElement.next().addClass("active");
								currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);
								removeElement.addClass("active");
							}

							targetParent.find(".validation_error").remove();
							targetParent.find(".error-input").removeClass("error-input");
							targetParent.find(".input-status").removeClass("input-status--incorrect");

							// recalculate the progress bar width.
							calculateProgressBar();
						} else {
							currentElement.removeClass("active");
							currentElement.children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', -1);

							// loop through all the cloned children and disable them all.
							while (currentElement.next().hasClass("quote-question--children")) {
								if (!currentElement.next().hasClass("c__loader--wrapper")) {
									currentElement.next().removeClass("active");
									currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', -1);
								}

								currentElement = currentElement.next();
							}

							if (currentElement.siblings(".quote-question__multiple-toggle").length) {
								currentElement.next().removeClass("active");
								currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', -1);
								removeElement.removeClass("active");
							}

							// recalculate the progress bar width.
							calculateProgressBar();
						}
					} else {
						let target = $(this).closest(".quote-question").data("target-children") ? "#" + $(this).closest(".quote-question").data("target-children").toString() : "";
						let targetParent = $(target).parent(".quote-question--children-wrapper");
						let currentElement = $(target);
						let removeElement = currentElement.siblings(".quote-question__multiple-remove");

						if ($(this).val()) {
							currentElement.addClass("active");
							currentElement.children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);

							// loop through all the cloned children and enable them all.
							while (currentElement.next().hasClass("quote-question--children")) {
								if (!currentElement.next().hasClass("c__loader--wrapper")) {
									currentElement.next().addClass("active");
									currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);
								}

								currentElement = currentElement.next();
							}

							if (currentElement.siblings(".quote-question__multiple-toggle").length) {
								currentElement.next().addClass("active");
								currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);
								removeElement.addClass("active");
							}

							targetParent.find(".validation_error").remove();
							targetParent.find(".error-input").removeClass("error-input");
							targetParent.find(".input-status").removeClass("input-status--incorrect");

							// recalculate the progress bar width.
							calculateProgressBar();
						} else {
							currentElement.removeClass("active");
							currentElement.children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', -1);

							// loop through all the cloned children and disable them all.
							while (currentElement.next().hasClass("quote-question--children")) {
								if (!currentElement.next().hasClass("c__loader--wrapper")) {
									currentElement.next().removeClass("active");
									currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', -1);
								}

								currentElement = currentElement.next();
							}

							if (currentElement.siblings(".quote-question__multiple-toggle").length) {
								currentElement.next().removeClass("active");
								currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', -1);
								removeElement.removeClass("active");
							}

							// recalculate the progress bar width.
							calculateProgressBar();
						}
					}

					toggleSelect2TabIndex();
				});
			} else {
				let values = $(this).closest(".quote-question").data("toggle-children") ? $(this).closest(".quote-question").data("toggle-children").toString().split(",") : null;

				if (values) {
					let input = $(this).closest(".quote-question").find('input[type="radio"]').length
							? $(this).closest(".quote-question").find('input[type="radio"]')
							: $(this).closest(".quote-question").find("select.quote-question--select"),
						inputSelected = $(this).closest(".quote-question").find('input[type="radio"]').length
							? $(this).closest(".quote-question").find('input[type="radio"]:checked')
							: $(this).closest(".quote-question").find("select.quote-question--select option:selected"),
						target = $(input).closest(".quote-question").data("target-children") ? "#" + $(input).closest(".quote-question").data("target-children").toString() : "",
						targetParent = $(target).parent(".quote-question--children-wrapper"),
						currentElement = $(target),
						removeElement = currentElement.siblings(".quote-question__multiple-remove");

					// if there is an already prefilled item, then check if we need to open its children.
					if (inputSelected) {
						if ($.inArray(inputSelected.val(), values) !== -1) {
							$(target).addClass("active");
							currentElement.children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);

							// loop through all the cloned children and enable them all.
							while (currentElement.next().hasClass("quote-question--children")) {
								if (!currentElement.next().hasClass("c__loader--wrapper")) {
									currentElement.next().addClass("active");
									currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);
								}

								currentElement = currentElement.next();
							}

							if (currentElement.siblings(".quote-question__multiple-toggle").length) {
								currentElement.next().addClass("active");
								currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);
								removeElement.addClass("active");
							}

							targetParent.find(".validation_error").remove();
							targetParent.find(".error-input").removeClass("error-input");
							targetParent.find(".input-status").removeClass("input-status--incorrect");

							// recalculate the progress bar width.
							calculateProgressBar();
						}
					}

					// if there was a change to the parent input/select, then check if we need to open its children.
					input.change(function () {
						let target = $(this).closest(".quote-question").data("target-children") ? "#" + $(this).closest(".quote-question").data("target-children").toString() : "";
						let targetParent = $(target).parent(".quote-question--children-wrapper");
						let currentElement = $(target);
						let removeElement = currentElement.siblings(".quote-question__multiple-remove");
						let hasChildren = 0;

						if ($.inArray($(this).val(), values) !== -1) {
							currentElement.addClass("active");
							currentElement.children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);

							// loop through all the cloned children and enable them all.
							while (currentElement.next().hasClass("quote-question--children")) {
								if (!currentElement.next().hasClass("c__loader--wrapper")) {
									currentElement.next().addClass("active");
									currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);
								}

								currentElement = currentElement.next();
								hasChildren++;
							}

							if (currentElement.siblings(".quote-question__multiple-toggle").length) {
								currentElement.next().addClass("active");
								currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', 0);
								removeElement.addClass("active");
							}

							targetParent.find(".validation_error").remove();
							targetParent.find(".error-input").removeClass("error-input");
							targetParent.find(".input-status").removeClass("input-status--incorrect");

							// recalculate the progress bar width.
							calculateProgressBar();
						} else {
							currentElement.removeClass("active");
							currentElement.children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', -1);

							// loop through all the cloned children and disable them all.
							while (currentElement.next().hasClass("quote-question--children")) {
								if (!currentElement.next().hasClass("c__loader--wrapper")) {
									currentElement.next().removeClass("active");
									currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', -1);
								}

								currentElement = currentElement.next();
							}

							if (currentElement.siblings(".quote-question__multiple-toggle").length) {
								currentElement.next().removeClass("active");
								currentElement.next().children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', -1);
								removeElement.removeClass("active");
							}

							// recalculate the progress bar width.
							calculateProgressBar();
						}

						toggleSelect2TabIndex();
					});
				}
			}
		});
	}
}

// function to duplicate existing question groups.
function ajaxDuplicateQuestionGroups() {
	$(document).on("click", ".quote-question__multiple-toggle", function (e) {
		e.preventDefault();

		var animPromise,
			ajaxPromise,
			pathArray = location.href.split("/"),
			protocol = pathArray[0],
			host = pathArray[2],
			ajax_url = protocol + "//" + host + "/wp-admin/admin-ajax.php";

		var result;
		var current = $(this);
		var children = current.data("sub-questions");
		var duplicate_count = parseInt(current.attr("data-duplicate-count")) + 1;
		var target = current.prev(".quote-question--children:not(.loaded)");
		var type = current.data("question-type");
		var group_multiple = current.data("group-multiple") ?? null;
		var remove_item = current.siblings(".quote-question__multiple-remove");
		var multiple_wrapper = current.closest(".quote-question--children-wrapper");
		var children_count = multiple_wrapper.find("> .quote-question--children.active").length;

		// [Additional Driver] custom logic and variables
		var is_additional_driver_child = false;
		var additional_driver_count = 0;
		var targetParent = current.parents(".quote-question--children-wrapper").last();
		var directParent = current.closest(".quote-question--children-wrapper").last();
		var max_items = directParent.data('max-items') ? directParent.data('max-items') : null;
		var additional_driver_parent = targetParent.find("> .quote-question__multiple-toggle");
		var direct_parent = current.closest(".quote-question--children.active");
		var additional_driver_container = $(".quote-question__additional-driver").next(".quote-question--children-wrapper").find(".quote-question--children.active");
		if (additional_driver_parent.data("question-type") == "additional-driver" && additional_driver_container.length > 0) {
			additional_driver_count = parseInt(direct_parent.attr("data-current-count")) + 1;
			if (additional_driver_count) {
				is_additional_driver_child = true;
			}
		}

		if((children_count + 1) > max_items && max_items > 0) {
			var consoleData = {
				'successful_call': false,
				'type': type,
				'group_multiple': group_multiple,
				'max_items': max_items,
				'duplicate_count': duplicate_count,
				'additional_driver_count': additional_driver_count,
				'additional_driver_parent': (additional_driver_parent.data("question-type") == "additional-driver"),
				'is_additional_driver_child': is_additional_driver_child,
			};

			window.mwConsoleLog(consoleData);

			if(type == 'additional-driver') {
				alert("Sorry, there is currently a maximum limit of " + max_items + " additional drivers that can be added as part of the quote.");
			} else {
				alert("Sorry, there is currently a maximum limit of " + max_items + " that can be added as part of the quote.");
			}
			$(this).removeClass('active');
		} else {
			// add fix in place for when [Additional Driver] is restricted to only 1 child (no multiple allowed).
			if (!is_additional_driver_child) {
				if (current.parents(".quote-question--children-wrapper").last().hasClass("additional-driver")) {
					is_additional_driver_child = true;
				}
			}

			if (is_additional_driver_child && additional_driver_count > 0) {
				remove_item.addClass("active");
			} else if (children_count > 0) {
				remove_item.addClass("active");
			}

			target.addClass("active").addClass("loading");

			animPromise = wait();
			ajaxPromise = $.ajax({
				type: "POST",
				url: ajax_url,
				dataType: "json",
				data: {
					action: "mw_ajax_duplicate_quote_question",
					children: children,
					duplicate_count: duplicate_count,
					group_multiple: group_multiple,
					additional_driver: is_additional_driver_child,
					additional_driver_count: additional_driver_count,
					type: type,
					is_child_question: true,
				},
				success: function (data) {
					result = data;
				},
				error: function (xhr, status, error) {
					console.error("Error occurred during AJAX request - status code:", xhr.status);
					console.error("Error occurred during AJAX request - message:", error);
				},
				complete: function () {
					window.mwConsoleLog("AJAX request complete.");
				},
			});
			$.when(animPromise, ajaxPromise).done(function () {
				var successful_call = false;

				$(target).removeClass("loading");

				if (result) {
					successful_call = true;

					// Mark element as loaded.
					target.addClass("loaded");
	
					// Append the AJAX-ed content.
					target.html(result);
	
					target.removeClass("c__loader--wrapper");
	
					// Append an empty container for future duplicates.
					target.after('<div class="quote-question--children"><div class="c__loader c__loader--dark"><div></div><div></div><div></div><div></div></div></div>');
	
					// Update the duplicate counter.
					current.attr("data-duplicate-count", duplicate_count);
	
					target.attr("data-current-count", duplicate_count);
	
					// Add functionality to toggle the boolean questions yes/no.
					addButtonEvents(target);
	
					// initialise select2 improved Dropdowns.
					addSelect2(target);
	
					// initialise flatpickr for DatePicker.
					// addDatePicker(target);
	
					// Add functionality to toggle On/Off question sub children.
					toggleQuestionChildren(target);
	
					// Add functionality to dynamically calculate someone's starting license number.
					calculateLicenceNumber(target.find(".quote-question"));
	
					// Add functionality to calculate the current scroll progress for the bar.
					calculateProgressBar();
	
					// addDynamicValidation(target);
	
					inputToUppercase(target);
	
					triggerConvictionCodeQuestion(target);
	
					checkDateInputs(target);

					triggerAdditionalDriverEmploymentQuestion(target);

					triggerAdditionalDriverOtherVehicleQuestion(target);
			
					triggerAdditionalDriverConvictionCodeQuestion(target);
			
					triggerAdditionalDriverMedicalConditionQuestion(target);

					additionalDriverCalculateTotalUKTime(target);

					prefillDateInput(target);
	
					if (is_additional_driver_child) {
						recalculateDropdowns(".details__additional_motor_what", ".details__additional_motor_type", target);
					} else {
						if (group_multiple == "modifications") {
							recalculateDropdowns(".car__modifications_category", ".car__modifications_type", target);
						} else {
							recalculateDropdowns(".details__motor_what", ".details__motor_type", target);
						}
					}
				} else {
					successful_call = false;

					target.addClass("error");
				}

				var consoleData = {
					'successful_call': successful_call,
					'type': type,
					'group_multiple': group_multiple,
					'max_items': max_items,
					'duplicate_count': duplicate_count,
					'additional_driver_count': additional_driver_count,
					'additional_driver_parent': (additional_driver_parent.data("question-type") == "additional-driver"),
					'is_additional_driver_child': is_additional_driver_child,
				};

				window.mwConsoleLog(consoleData);
			});
		}
	});

	$(document).on("click", ".quote-question__multiple-remove--current", function (e) {
		e.preventDefault();

		var current = $(this).closest(".quote-question--children.active");
		var add_multiple = current.siblings(".quote-question__multiple-toggle");

		// only the first child block carries the parent question's target-children id;
		// hand it to the next block before removing, or toggling the parent off can no longer find/hide its children.
		var target_id = current.attr("id");
		if (target_id) {
			// an empty placeholder appended by the AJAX add has no c__loader--wrapper class, so match on
			// blocks that actually hold questions rather than on the placeholder class alone.
			var next_block = current.nextAll(".quote-question--children").filter(function () {
				return $(this).find(".quote-question").length > 0;
			}).first();
			if (next_block.length) {
				next_block.attr("id", target_id);
			}
		}

		current.remove();

		if(!add_multiple.hasClass('active')) {
			add_multiple.addClass('active');
		}
	});


	$(document).on("click", ".quote-question__multiple-remove", function (e) {
		e.preventDefault();

		var previous = $(this).prev();
		var duplicate_count = parseInt(previous.attr("data-duplicate-count")) - 1;
		var last_item = $(this).siblings(".quote-question--children.active.loaded").last();
		var add_multiple = $(this).siblings(".quote-question__multiple-toggle");

		if (last_item.length) {
			previous.attr("data-duplicate-count", duplicate_count);
			last_item.remove();

			// this is set to -1 in order to hide if there's no longer items to be removed.
			if (duplicate_count == -1) {
				$(this).removeClass("active");
			}
		} else {
			var last_item = $(this).siblings(".quote-question--children.active:not(.c__loader--wrapper)").last();

			previous.attr("data-duplicate-count", duplicate_count);
			last_item.remove();

			// this is set to -1 in order to hide if there's no longer items to be removed.
			if (duplicate_count == -1) {
				$(this).removeClass("active");
			}
		}

		if(!add_multiple.hasClass('active')) {
			add_multiple.addClass('active');
		}
	});
}

function triggerNewLicenseNumber() {
	var title = $(".quote-question__title").find("select"),
		forename = $(".quote-question__firstname").find(".quote-question__input-wrapper input"),
		surname = $(".quote-question__lastname").find(".quote-question__input-wrapper input"),
		dateOfBirth = $(".quote-question__dob").find(".quote-question__input-wrapper input");
	oldDateOfBirthValue = dateOfBirth.val();

	// Namespaced + de-bound so this stays idempotent when called again (e.g. from the CRO licence variation).
	title.off("change.licence").on("change.licence", function () {
		calculateLicenceNumber($(this).closest(".quote-question"), true, "title");
	});

	forename.off("change.licence").on("change.licence", function () {
		calculateLicenceNumber($(this).closest(".quote-question"), true, "forename");
	});

	surname.off("change.licence").on("change.licence", function () {
		calculateLicenceNumber($(this).closest(".quote-question"), true, "surname");
	});

	dateOfBirth.off("blur.licence").on("blur.licence", function () {
		if ($(this).val() != oldDateOfBirthValue) {
			oldDateOfBirthValue = $(this).val();
			calculateLicenceNumber($(this).closest(".quote-question"), true, "dateOfBirth");
		}
	});
}

// Expose licence helpers so other extras bundles (e.g. license.js) can reuse them.
window.triggerNewLicenseNumber = triggerNewLicenseNumber;
window.calculateLicenceNumber = calculateLicenceNumber;

// function to dynamically calculate someone's starting license number.
function calculateLicenceNumber(target, onChange = false, type = "", directParent = false) {
	// initialise all custom variables we need to dynamically generate the license number.
	var animPromise,
		ajaxPromise,
		pathArray = location.href.split("/"),
		protocol = pathArray[0],
		host = pathArray[2],
		ajax_url = protocol + "//" + host + "/wp-admin/admin-ajax.php",
		licenseTarget = !directParent ? target.siblings(".quote-question__license-number") : target,
		license_first = licenseTarget.find(".license-first"),
		license_second = licenseTarget.find(".license-second"),
		license_third = licenseTarget.find(".license-third"),
		license_none = licenseTarget.find(".license-number-none"),
		title = target.siblings(".quote-question__title").find("select").val(),
		forename = target.siblings(".quote-question__firstname").find(".quote-question__input-wrapper input").val(),
		surname = target.siblings(".quote-question__lastname").find(".quote-question__input-wrapper input").val(),
		dateOfBirth = target.siblings(".quote-question__dob").find(".quote-question__input-wrapper input").val();

	if(license_first.val() && license_second.val() && license_third.val()) {
		if(license_first.val().length == 5 && license_second.val().length == 6 && license_third.val().length == 5) {
			return;
		}
	}

	if (type) {
		switch (type) {
			case "title":
				title = target.find("select").val();
				break;

			case "forename":
				forename = target.find(".quote-question__input-wrapper input").val();
				break;

			case "surname":
				surname = target.find(".quote-question__input-wrapper input").val();
				break;

			case "dateOfBirth":
				dateOfBirth = target.find(".quote-question__input-wrapper input").val();
				break;
		}
	}

	// make sure we only trigger the AJAX if there's a license target, and all values needed.
	if ($(licenseTarget).length && title && forename && surname && dateOfBirth) {
		// make sure we only trigger the AJAX if there's an empty value within the license number or there's a JS change event.
		if (onChange || ((!license_first.val() || !license_second.val() || !license_third.val()) && license_none.val() != "true")) {
			license_none.removeAttr("checked");

			animPromise = wait();
			ajaxPromise = $.ajax({
				type: "POST",
				url: ajax_url,
				dataType: "json",
				data: {
					action: "mw_ajax_get_license_number",
					title: title,
					forename: forename,
					surname: surname,
					dateOfBirth: dateOfBirth,
				},
				success: function (data) {
					result = data;
				},
				error: function (xhr, status, error) {
					console.error("Error occurred during AJAX request - status code:", xhr.status);
					console.error("Error occurred during AJAX request - message:", error);
				},
				complete: function () {
					window.mwConsoleLog("AJAX request complete.");
				},
			});
			$.when(animPromise, ajaxPromise).done(function () {
				let formatted_first = "",
					formatted_second = "",
					formatted_third = "",
					license_number = JSON.parse(result);

				$.each(license_number, function (index, value) {
					if (index >= 0 && index < 5) {
						formatted_first = formatted_first + value;
					} else if (index >= 5 && index < 11) {
						formatted_second = formatted_second + value;
					} else if (index == 11) {
						formatted_third = formatted_third + value;
					}
				});

				window.mwConsoleLog(license_number);

				license_first.val(formatted_first);
				license_second.val(formatted_second);
				license_third.val(formatted_third);

				licenseTarget.addClass("show-placeholder");
			});
		}
	}

	license_third.hover(function () {
		licenseTarget.removeClass("show-placeholder");
	});

	license_third.on("change", function () {
		if ($(this).val().length == 1) {
			licenseTarget.addClass("show-placeholder");
		}
	});

	license_third.mouseleave(function () {
		if ($(this).val().length == 1) {
			licenseTarget.addClass("show-placeholder");
		}
	});
}

function addBrowserDetails() {
	const BrowserColorDepth = $("input[name=BrowserColorDepth]"),
		BrowserJavaEnabled = $("input[name=BrowserJavaEnabled]"),
		BrowserLanguage = $("input[name=BrowserLanguage]"),
		BrowserScreenHeight = $("input[name=BrowserScreenHeight]"),
		BrowserScreenWidth = $("input[name=BrowserScreenWidth]"),
		BrowserUserAgent = $("input[name=BrowserUserAgent]"),
		BrowserTZ = $("input[name=BrowserTZ]");

	if (BrowserColorDepth.length) {
		const colorDepth = screen.colorDepth || screen.pixelDepth;

		BrowserColorDepth.val(colorDepth.toString());
	}

	if (BrowserJavaEnabled.length) {
		const javaEnabled = navigator.javaEnabled();

		BrowserJavaEnabled.val(javaEnabled.toString());
	}

	if (BrowserLanguage.length) {
		const language = navigator.language || navigator.userLanguage;

		BrowserLanguage.val(language.toString());
	}

	if (BrowserScreenHeight.length) {
		const screenHeight = window.screen.height;
		BrowserScreenHeight.val(screenHeight.toString());
	}

	if (BrowserScreenWidth.length) {
		const screenWidth = window.screen.width;
		BrowserScreenWidth.val(screenWidth.toString());
	}

	if (BrowserUserAgent.length) {
		const userAgent = navigator.userAgent;
		BrowserUserAgent.val(userAgent.toString());
	}

	if (BrowserTZ.length) {
		const timezone = new Date().getTimezoneOffset() / 60;

		BrowserTZ.val(timezone.toString());
	}
}

function submitMultiProductPage() {
	$(document).on("change", "input[name=quote_option--multi-product]", function () {
		$(this).closest('.quote__option-wrapper').addClass('loading');
		$("#form-multi-product").submit();
	});
}

function submitQuoteResultsPage() {
	$(document).on("change", "input[name=quote_option]", function () {
		// clear any errors that were previously flagged.
		$(this).closest(".quote__option").find("input[name^=quote-start-").closest(".quote-question__date").next(".validation_error").remove();
		$(this).closest(".quote__option").find("input[name^=quote-start-").removeClass("error");

		let quoteStart = $(this).closest(".quote__option").find("input[name^=quote-start-");

		let now = new Date(),
			currentDate = new Date(now.getTime()),
			year = currentDate.getFullYear(),
			month = String(currentDate.getMonth() + 1).padStart(2, "0"),
			day = String(currentDate.getDate()).padStart(2, "0"),
			hours = String(currentDate.getHours()).padStart(2, "0"),
			minutes = String(currentDate.getMinutes()).padStart(2, "0"),
			formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}`;

        // comment this out as per Rebecca's request.
		// // update [date min] in order to dynamically validate the [Quote Start] input field.
		// quoteStart.attr("data-min", formattedTimestamp);

		let validate = handleDateInput(quoteStart);

		if (validate.status == false) {
			let error = document.createElement("span");
			error.className = "validation_error";
			error.innerHTML = validate.message;
			$(error.outerHTML).insertAfter(quoteStart.closest(".quote-question__date"));
			quoteStart.closest(".quote-question__date").addClass("error");

			$("html, body").animate(
				{
					scrollTop: $(quoteStart).offset().top - 150,
				},
				500
			);

			$(this).prop("checked", false);
			$(this).blur();
		} else {
			let quoteStartDateCompare = (quoteStartDate = parseUKDate(quoteStart.val())),
				previousHours = quoteStart.attr("data-hours") ?? "",
				previousMinutes = quoteStart.attr("data-minutes") ?? "";

            if(previousHours && previousMinutes && !yourPolicyQuoteStartDateUpdated) {
				if (parseInt(previousHours) == quoteStartDate.getHours() && parseInt(previousMinutes) == quoteStartDate.getMinutes()) {
					quoteStartDateCompare.setHours(0, 0, 0, 0);
					currentDate.setHours(0, 0, 0, 0);

					// Calculate the date difference in milliseconds (1 day equals 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
					let oneDayDifferenceInMs = 24 * 60 * 60 * 1000;

					// [Quote Start] input date is in the future by at least 1 day.
					if (quoteStartDateCompare.getTime() - currentDate.getTime() >= oneDayDifferenceInMs) {
						// Add 1 minute to the current date and time
						quoteStartDate.setMinutes(quoteStartDate.getMinutes() + 1);

						let year = quoteStartDate.getFullYear(),
							month = String(quoteStartDate.getMonth() + 1).padStart(2, "0"),
							day = String(quoteStartDate.getDate()).padStart(2, "0"),
							hours = String(quoteStartDate.getHours()).padStart(2, "0"),
							minutes = String(quoteStartDate.getMinutes()).padStart(2, "0"),
							// formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}`;
							formattedTimestamp = `${year}-${month}-${day} ${previousHours}:${previousMinutes}`;

						quoteStart.val(formattedTimestamp).trigger("change");

						yourPolicyQuoteStartDateUpdated = true;
					}
				}
			}

			quoteStart.attr("data-hours", quoteStartDate.getHours());
			quoteStart.attr("data-minutes", quoteStartDate.getMinutes());

			if ($(".content-your-details__missing--wrapper").length) {
				$("input[name=quote_option]:checked").prop("checked", false);
				lity(".content-your-details__missing--wrapper");
			} else {
				$(this).closest('.quote__option-wrapper').addClass('loading');
				$("#form-quote-results").submit();
			}
		}
	});
}

function handleDateInput(valItem) {
	let valid = { status: valItem.val().length >= 1, message: "Please enter a date" };

	if ($(valItem).attr("data-min") && $(valItem).val().length) {
		if ($(valItem).attr("class").includes("start-date")) {
			// if it hasn't been previously initialised, do it once.
			if (!quoteResultsStartDate) {
				quoteResultsStartDate = $(valItem).val();
			}
	
			// if the value has ever changed, then mark it.
			if ($(valItem).val() != quoteResultsStartDate) {
				$(valItem).attr("data-value-changed", "true");
			}
		}

		var now = new Date(),
		currentDate = new Date(now.getTime()),
		date = parseUKDate($(valItem).val()),
		minDate = parseUKDate($(valItem).attr("data-min")),
		minDateCheck = parseUKDate($(valItem).attr("data-min")),
		startTime = parseUKDate($(valItem).attr("data-start-time")),
		startTimeCheck = parseUKDate($(valItem).attr("data-start-time")),
		startTimeMaxCheck = parseUKDate($(valItem).attr("data-start-time")),
		previouslyAltered = $(valItem).attr("data-value-changed");

		// dynamically adjust the [data-min] attribute for [Quote Start Date] input.
		if(previouslyAltered) {
				var now = new Date(),
				// currentDate = new Date(now.getTime() + 10 * 60000), // appent 10 minutes to the current date.
				currentDate = new Date(now.getTime()),
				year = currentDate.getFullYear(),
				month = String(currentDate.getMonth() + 1).padStart(2, '0'),
				day = String(currentDate.getDate()).padStart(2, '0'),
				hours = String(currentDate.getHours()).padStart(2, '0'),
				minutes = String(currentDate.getMinutes()).padStart(2, '0'),
				formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}`;

				valItem.attr("data-min", formattedTimestamp);
				
				previouslyAltered = false;
		}
	
		if(minDateCheck) {
			minDateCheck.setMinutes(minDateCheck.getMinutes() + 10); // normal validation will need the 10 minutes in the future flag.
		}

		if(startTimeCheck) {
			startTimeCheck.setMinutes(startTimeCheck.getMinutes() + 8); // allow up to 8 minutes of time being spent on the page prior to validating.
		}

		if(startTimeMaxCheck) {
			startTimeMaxCheck.setMinutes(startTimeMaxCheck.getMinutes() + 18); // total allowance is minimum of 10 minutes + the additional buffer time. 
		}

		if(date) {
        	date.setSeconds(0, 0);
		}

		if(minDate) {
			minDate.setSeconds(0, 0);
		}

		if(currentDate) {
			currentDate.setSeconds(0, 0);
		}
	
		if (date.getTime() < currentDate.getTime()) {
			valid.status = false;
			const readableDate = minDate.toLocaleDateString();

			if ($(valItem).attr("class").includes("start-date")) {
				valid.message = "The start date cannot be in the past";
				// valid.message = "Earliest cover " + readableDate;
			} else {
				valid.message = "Earliest date " + readableDate;
			}

			// if ($(valItem).attr("type") == "datetime-local") {
			// 	const readableTime = minDate.toLocaleTimeString();
			// 	valid.message += " " + readableTime;
			// }
		}
	}

	if (valItem.attr("data-max") && valItem.val().length) {
		var date = parseUKDate(valItem.val());
		var max = parseUKDate(valItem.attr("data-max"));

		if (date.getTime() > max.getTime()) {
			valid.status = false;

			const readableDate = max.toLocaleDateString();
			valid.message = "Maximum date " + readableDate;

			if (valItem.attr("type") == "datetime-local") {
				const readableTime = max.toLocaleTimeString();
				valid.message += " " + readableTime;
			}
		}
	}

	return valid;
}

function triggerNewQuoteResults() {
	// [Quote Cover] input CHANGE event.
	$(document).on("change", "select[name^=quote-cover-]", function () {
		var length = $(this).closest(".quote__option-wrapper").attr("data-quote-length");
		getNewQuoteResults(length, null, true);
	});

	// [Quote Duration] input CHANGE event.
	$(document).on("change", "input[name=quote-duration]", function () {
		var length = $(this).closest(".quote__option-wrapper").attr("data-quote-length");
		getNewQuoteResults(length);
	});

	// store the previous value for the [Quote Start] input field.
	var quoteStartPreviousValue = "";

	// [Quote Start] input FOCUS event.
	$(document).on("focus", "input[name^=quote-start-]", function () {
		quoteStartPreviousValue = $(this).val();
	});

	// [Quote Start] input CHANGE & BLUR event.
	$(document).on("focusout", "input[name^=quote-start-]", function () {
		var quoteStartNewValue = $(this).val();

		if (quoteStartNewValue && quoteStartNewValue != quoteStartPreviousValue) {
			// clear any errors that were previously flagged.
			$(this).closest(".quote-question__date").next(".validation_error").remove();
			$(this).closest(".quote-question__date.error").removeClass("error");

			let length = $(this).closest(".quote__option-wrapper").attr("data-quote-length"),
				now = new Date(),
				// currentDate = new Date(now.getTime() + 10 * 60000), // appent 10 minutes to the current date.
				currentDate = new Date(now.getTime()),
				year = currentDate.getFullYear(),
				month = String(currentDate.getMonth() + 1).padStart(2, "0"),
				day = String(currentDate.getDate()).padStart(2, "0"),
				hours = String(currentDate.getHours()).padStart(2, "0"),
				minutes = String(currentDate.getMinutes()).padStart(2, "0"),
				formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}`;

			// update [date min] in order to dynamically validate the [Quote Start] input field.
			$(this).attr("data-min", formattedTimestamp);

			let validate = handleDateInput($(this));

			if (validate.status == false) {
				let error = document.createElement("span");
				error.className = "validation_error";
				error.innerHTML = validate.message;
				$(error.outerHTML).insertAfter($(this).closest(".quote-question__date"));
				$(this).closest(".quote-question__date").addClass("error");
			} else {
				let quoteStartDateCompare = (quoteStartDate = parseUKDate(quoteStartNewValue)),
					previousHours = $(this).attr("data-hours") ?? "",
					previousMinutes = $(this).attr("data-minutes") ?? "";

            	if(previousHours && previousMinutes && !yourPolicyQuoteStartDateUpdated) {
					if (parseInt(previousHours) == quoteStartDate.getHours() && parseInt(previousMinutes) == quoteStartDate.getMinutes()) {
						quoteStartDateCompare.setHours(0, 0, 0, 0);
						currentDate.setHours(0, 0, 0, 0);

						// Calculate the date difference in milliseconds (1 day equals 24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
						let oneDayDifferenceInMs = 24 * 60 * 60 * 1000;

						// [Quote Start] input date is in the future by at least 1 day.
						if (quoteStartDateCompare.getTime() - currentDate.getTime() >= oneDayDifferenceInMs) {
							// Add 1 minute to the current date and time
							quoteStartDate.setMinutes(quoteStartDate.getMinutes() + 1);

							let year = quoteStartDate.getFullYear(),
								month = String(quoteStartDate.getMonth() + 1).padStart(2, "0"),
								day = String(quoteStartDate.getDate()).padStart(2, "0"),
								hours = String(quoteStartDate.getHours()).padStart(2, "0"),
								minutes = String(quoteStartDate.getMinutes()).padStart(2, "0"),
								formattedTimestamp = `${year}-${month}-${day} ${hours}:${minutes}`;

							$(this).val(formattedTimestamp).trigger("change");

							yourPolicyQuoteStartDateUpdated = true;
						}
					}
				}

				$(this).attr("data-hours", quoteStartDate.getHours());
				$(this).attr("data-minutes", quoteStartDate.getMinutes());

				getNewQuoteResults(length);
			}
		}
	});

	// [Quote Addons] input CHANGE event.
	$(document).on("change", "input[name^=quote-addons]:not(.category--Breakdown)", function () {
		var length = $(this).closest(".quote__option-wrapper").attr("data-quote-length");
		getNewQuoteResults(length, null, true);
	});

	// [Quote Pay] input CHANGE event.
	$(document).on("change", "input[name=quote-pay]", function () {
		var length = $(this).closest(".quote__option-wrapper").attr("data-quote-length");
		var policyID = $(this).closest(".quote__option-wrapper").find('input[name=quote-policyid-long]').val();
		var quoteData = $(this).closest(".quote__option-wrapper").find('input[name=quote-data-long]').val();
		getNewQuoteResults(length, policyID, false, quoteData);

		if($(this).val() == 'monthly') {
			$('.display-quote__label.long').find('.display-quote__duration.year.active').removeClass('active');
			$('.display-quote__label.long').find('.display-quote__duration.month').addClass('active');
		} else {
			$('.display-quote__label.long').find('.display-quote__duration.month.active').removeClass('active');
			$('.display-quote__label.long').find('.display-quote__duration.year').addClass('active');
		}
	});
}

function isElementVisible(element) {
	return window.getComputedStyle(element).display !== "none";
}

function triggerMultiProductRequote() {
	if($('[name=multi-product-cover]').length) {
		var animPromise,
		ajaxPromise,
		pathArray = location.href.split("/"),
		protocol = pathArray[0],
		host = pathArray[2],
		ajax_url = protocol + "//" + host + "/wp-admin/admin-ajax.php",
	 	urlParams = new URLSearchParams(window.location.search),
		qid = urlParams.get("qid");

		$('[name=multi-product-cover]').on('change', function() {
			var target = $('.multi-product__wrapper');
			var quoteCookie = getCookieValue("quote");
			var quoteIsAA = $("input[name=quote-is-aa]").val();
			var quotePromotionCode = $("input[name=quote-promotion-code]").val();
			var quoteCover = $(this).val();
			var quoteDiscount = $("input[name=quote-discount]").val();
			var logMessage = {
				action: "mw_ajax_get_quote_results",
				quote: quoteCookie,
				cover: quoteCover,
				isAA: quoteIsAA,
				promotionCode: quotePromotionCode,
				qid: qid,
			};

			window.mwConsoleLog(logMessage);

			$(target).addClass('loading');
			$(target).prop("disabled", true);

			animPromise = wait();
			ajaxPromise = $.ajax({
				type: "POST",
				url: ajax_url,
				dataType: "json",
				data: {
					action: "mw_ajax_multi_product_requote",
					quote: quoteCookie,
					cover: quoteCover,
					discount: quoteDiscount,
					isAA: quoteIsAA,
					promotionCode: quotePromotionCode,
					qid: qid,
				},
				success: function (data) {
					result = data;
				},
				error: function (xhr, status, error) {
					console.error("Error occurred during AJAX request - status code:", xhr.status);
					console.error("Error occurred during AJAX request - message:", error);
					alert("The following request failed, please try refreshing the page.");
				},
				complete: function () {
					window.mwConsoleLog("AJAX request complete.");
				},
			});
			$.when(animPromise, ajaxPromise).done(function () {
				$(target).removeClass("loading");

				if (result && result != "[]") {
					// // Mark element as loaded.
					$(target).addClass("loaded");
					$(target).prop("disabled", false);

					// // Append the AJAX-ed content.
					$(target).html(result);
				} else {
					alert("The following request failed, please try refreshing the page.");
				}
			});
		});
	}
}

function getNewQuoteResults(length, policyID = null, newAddons = false, quoteDataJWT = []) {
	var animPromise,
		ajaxPromise,
		pathArray = location.href.split("/"),
		protocol = pathArray[0],
		host = pathArray[2],
		ajax_url = protocol + "//" + host + "/wp-admin/admin-ajax.php",
	 	urlParams = new URLSearchParams(window.location.search),
		qid = urlParams.get("qid");

	var quoteCookie = "";
	var quoteIsAggregator = false;
	var is_aggregator = getCookieValue("aggregator");
	if (is_aggregator == "true" || is_aggregator == true) {
		var quoteIsAggregator = true;
		quoteCookie = getCookieValue("aggregator_data");
	} else {
		quoteCookie = getCookieValue("quote");
	}

	var result = "";
	var targetClass = ".quote__option-wrapper--" + length;
	var target = $(targetClass);
	var quoteCover = $("select[name=quote-cover-" + length + "] option:checked").val();
	var quoteStartDate = $("input[name=quote-start-" + length + "]").val();
	var quoteAddons = $("input[name^=quote-addons]");
	var quoteDiscount = $("input[name=quote-discount]").val();
	var quotePromotionCode = $("input[name=quote-promotion-code]").val();
	var quoteProductId = $("input[name=quote-productid-" + length + "]").val();
	var quoteIsAA = $("input[name=quote-is-aa]").val();
	var quoteVehicleAge = $("input[name=quote-vehicle-age]").val();
	var quotePay = $("input[name=quote-pay]:checked").val();
	var quoteToken = $("input[name=quote-token]").val();
	var QuoteIsRenewal = $("input[name=is_renewal]").val();

	var quoteDuration = null;
	var quoteHasDurationWeeks = false;
	if (length == "short") {
		quoteDuration = $("input[name=quote-duration]:checked").val();
		quoteDurationWeeks = quoteDuration / 7;

		if(quoteDurationWeeks > 1) {
			quoteHasDurationWeeks = true;
		}
	}

	if (quoteAddons) {
		var checkedQuoteAddons = {};
		quoteAddons.each(function () {
			if ($(this).is(":checked")) {
				checkedQuoteAddons[$(this).data('code')] = parseInt($(this).val());
			}
		});
	}

	target.addClass("loading");
	target.prop("disabled", true);

	var logMessage = {
		action: "mw_ajax_get_quote_results",
		length: length,
		quote: quoteCookie,
		cover: quoteCover,
		duration: quoteDuration,
		startDate: quoteStartDate,
		addons: JSON.stringify(checkedQuoteAddons),
		discount: quoteDiscount,
		isAA: quoteIsAA,
		promotionCode: quotePromotionCode,
		productId: quoteProductId,
		vehicleAge: quoteVehicleAge,
		pay: quotePay,
		token: quoteToken,
		isAggregator: quoteIsAggregator,
		isRenewal: QuoteIsRenewal,
		policyID: policyID,
		newAddons: newAddons,
		qid: qid,
		quoteDataJWT: quoteDataJWT,
	};

	window.mwConsoleLog(logMessage);

	animPromise = wait();
	ajaxPromise = $.ajax({
		type: "POST",
		url: ajax_url,
		dataType: "json",
		data: {
			action: "mw_ajax_get_quote_results",
			length: length,
			quote: quoteCookie,
			cover: quoteCover,
			duration: quoteDuration,
			startDate: quoteStartDate,
			addons: JSON.stringify(checkedQuoteAddons),
			discount: quoteDiscount,
			isAA: quoteIsAA,
			promotionCode: quotePromotionCode,
			productId: quoteProductId,
			vehicleAge: quoteVehicleAge,
			pay: quotePay,
			token: quoteToken,
			isAggregator: quoteIsAggregator,
			isRenewal: QuoteIsRenewal,
			policyID: policyID,
			newAddons: newAddons,
			qid: qid,
			quoteDataJWT: quoteDataJWT,
		},
		success: function (data) {
			result = data;
		},
		error: function (xhr, status, error) {
			console.error("Error occurred during AJAX request - status code:", xhr.status);
			console.error("Error occurred during AJAX request - message:", error);
			alert("The following request failed, please try refreshing the page.");
		},
		complete: function () {
			window.mwConsoleLog("AJAX request complete.");
		},
	});
	$.when(animPromise, ajaxPromise).done(function () {
		$(target).removeClass("loading");

		if (result && result != "[]") {
			// Mark element as loaded.
			$(target).addClass("loaded");
			$(target).prop("disabled", false);

			// Append the AJAX-ed content.
			$(target).replaceWith(result);

			// Functionality to update the parent tab quote value.
			let quoteLabel = "";
			if (length == "long") {
				quoteLabel = $(".quote-option-label--long");
			} else {
				quoteLabel = $(".quote-option-label--short");
			}

			// If there's a value defined.
			if (quoteLabel.data("calculated")) {
				let quoteValue = quoteLabel.data("calculated"),
					target = "";
					targetLength = "";

				// update it accordingly depending whether it's annual/short term policy.
				if (length == "long") {
					target = $("#display_quote_long").next("label").find("span.price");
				} else if (length == "short") {
					target = $("#display_quote_short").next("label").find("span.price");
					targetLength = $("#display_quote_short").next("label").find("span.length");
					targetLengthLabel = $("#display_quote_short").next("label").find("span.length").next('span');
				}

				target.text(quoteValue);

				if(length == "short") {
					if(quoteHasDurationWeeks) {
						targetLength.text(quoteDurationWeeks);
						targetLengthLabel.text('week(s)');
					} else {
						targetLength.text(quoteDuration);
						targetLengthLabel.text('day(s)');
					}
				}
			} else {
				if (length == "long") {
					targetPrice = $("#display_quote_long").next("label").find("span.price");
					targetDuration = $("#display_quote_long").next("label").find(".display-quote__duration.active");
				}

				targetPrice.text('');
				targetDuration.removeClass('active');
			}

			wait();
			// functionality to initialise flatpickr for the AJAXed Quote Results.
			// addDatePicker($(".quote__option-period"));

			// functionality to initialise breakdown selection.
			addonBreakdownSelection();

			triggerDefaultDatePicker();

			addSelect2($(".quote__option-covers"));
		} else {
			alert("The following request failed, please try refreshing the page.");
		}
	});
}

function getCookieValue(cookieName) {
	var name = cookieName + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var cookieArray = decodedCookie.split(";");

	for (var i = 0; i < cookieArray.length; i++) {
		var cookie = cookieArray[i].trim();
		if (cookie.indexOf(name) == 0) {
			return cookie.substring(name.length, cookie.length);
		}
	}
	return "";
}

function resetQuoteResultInputs() {
	$(window).on("pageshow", function (event) {
		if (event.originalEvent.persisted || (window.performance && window.performance.navigation.type === 2)) {
			getNewQuoteResults("short");
			getNewQuoteResults("long");
		}
	});
}

function addButtonPressedAnimation() {
	$(".btn, .quote-question__boolean-btn:not(.readonly)").mousedown(function () {
		$(this).addClass("btn-pressed");
	});

	$(".btn, .quote-question__boolean-btn:not(.readonly)").mouseup(function () {
		$(this).removeClass("btn-pressed");
	});

	$(".btn, .quote-question__boolean-btn:not(.readonly)").on("tap", function () {
		$(this).removeClass("btn-pressed");
	});

	$(".btn, .quote-question__boolean-btn:not(.readonly)").mouseout(function () {
		$(this).removeClass("btn-pressed");
	});
}

function formatPrice(input) {
	var price;
	input = +input;

	if (input % 1 === 0) {
		price = input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	} else {
		//price = parseFloat(input).toFixed( 2 );

		price = parseInt(input);
		price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	// if (price.indexOf(symbol) === -1) {
	// 	price = symbol + (price === '' ? '0' : price);
	// }

	return price;
}

function recalculateDropdowns(categoriesClass, typesClass, target = null) {
	if ($(categoriesClass).length && $(typesClass).length) {
		var parent = target ? target : document;
		var categories = $(parent).find(categoriesClass);
		var categoriesSelect = categories.find(".quote-question--select");
		var types = $(categories).siblings(typesClass);
		var typesSelect = types.find(".quote-question--select");

		categoriesSelect.on("change", function () {
			var chosenCategory = $(this).find("option:selected").data("parent-category");

			typesSelect.removeAttr("disabled");

			typesSelect.find("option").each(function () {
				if ($(this).data("child-category") != chosenCategory) {
					$(this).addClass("hidden");
				} else {
					$(this).removeClass("hidden");
				}
			});

			typesSelect.select2("destroy");
			typesSelect.addClass("skip");
			typesSelect.val(null).trigger("change");
			typesSelect.select2({
				minimumResultsForSearch: 7,
				templateResult: function (state) {
					let $option = $(state.element);
					if ($option.hasClass("hidden")) {
						return null;
					}
					return state.text;
				},
			});
		});
	}
}

// Function to remove a specific cookie by name.
function removeCookie(cookieName) {
	document.cookie = cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

// Function to reset the Quote Cookie.
function resetQuoteCookie() {
	if ($(".btn--reset").length) {
		$(".btn--reset").on("click", function (e) {
			e.preventDefault();

			removeCookie("quote");

			var redirect = $(this).attr("href");
			window.location.href = redirect;
		});
	}
}

function buttonCorrectDetails() {
	if ($(".btn--details-correct").length) {
		$(".btn--details-correct").on("click", function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
			}
		});
	}
}

function triggerCarOwnerQuestion() {
	if ($("input[name=car__owner]").length) {
		// gather all variables needed.
		var car__owner = $("input[name=car__owner]"),
			parent = car__owner.closest(".quote-question"),
			car__owner_who = parent.siblings(".quote-question--owner"),
			car__owner_who_select = car__owner_who.find("select[name=car__owner_who]"),
			car__owner_keeper_select = car__owner_who.find("select[name=car__owner_keeper]");

		// hide the dropdowns by default.
		car__owner_who.hide();

		// toggle inner question based on input change.
		car__owner.on("change", function () {
			car__owner_who.find(".validation_error").remove();
			car__owner_who.find(".error-input").removeClass("error-input");
			car__owner_who.find(".input-status").removeClass("input-status--incorrect input-status--correct");
			car__owner_who_select.addClass("skip");
			car__owner_keeper_select.addClass("skip");

			if ($(this).val() && $(this).val() == "false") {
				car__owner_who.show();

				car__owner_who_select.val(null).trigger("change");
				car__owner_keeper_select.val(null).trigger("change");
			} else {
				car__owner_who.removeClass('active');
				car__owner_who.hide();

				car__owner_who_select
					.find("option")
					.filter(function () {
						// For reference, ID 1 used to be [Policy Holder].
						if ($(this).val() == "1") {
							return true;
						}

						return false;
					})
					.prop("selected", true)
					.removeClass("hidden");
				car__owner_who_select.trigger("change");

				car__owner_keeper_select
					.find("option")
					.filter(function () {
						// For reference, ID 1 used to be [Policy Holder].
						if ($(this).val() == "1") {
							return true;
						}

						return false;
					})
					.prop("selected", true)
					.removeClass("hidden");
				car__owner_keeper_select.trigger("change");
			}
		});

		// if the question was prefilled and has a value.
		if($('input[name=car__owner]:checked')) {
			if ($('input[name=car__owner]:checked').val() && $('input[name=car__owner]:checked').val() == "false") {
				car__owner_who.show();

				car__owner_who_select__selected = car__owner_who_select.find('option:selected').val();
				car__owner_keeper_select__selected = car__owner_keeper_select.find('option:selected').val();

				car__owner_who_select.val(car__owner_who_select__selected).trigger("change");
				car__owner_who_select
					.find("option")
					.filter(function () {
						// For reference, ID 1 used to be [Policy Holder].
						if ($(this).val() == "1") {
							return true;
						}

						return false;
					})
					.addClass("hidden");

				car__owner_who_select.select2("destroy");
				car__owner_who_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});

				car__owner_keeper_select.val(car__owner_keeper_select__selected).trigger("change");
				car__owner_keeper_select
					.find("option")
					.filter(function () {
						// For reference, ID 1 used to be [Policy Holder].
						if ($(this).val() == "1") {
							return true;
						}

						return false;
					})
					.addClass("hidden");

				car__owner_keeper_select.select2("destroy");
				car__owner_keeper_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			} else {
				car__owner_who.hide();

				car__owner_who_select
					.find("option")
					.filter(function () {
						// For reference, ID 1 used to be [Policy Holder].
						if ($(this).val() == "1") {
							return true;
						}

						return false;
					})
					.prop("selected", true)
					.removeClass("hidden");
				car__owner_who_select.trigger("change");

				car__owner_keeper_select
					.find("option")
					.filter(function () {
						// For reference, ID 1 used to be [Policy Holder].
						if ($(this).val() == "1") {
							return true;
						}

						return false;
					})
					.prop("selected", true)
					.removeClass("hidden");
				car__owner_keeper_select.trigger("change");
			}
		}
	}
}

function triggerOtherVehicleQuestion() {
	if ($("input[name=car__other_toggle]").length) {
		// gather all variables needed.
		var car__other_toggle = $("input[name=car__other_toggle]"),
			parent = car__other_toggle.closest(".quote-question"),
			car__other = parent.siblings(".quote-question--carOther"),
			car__other_wrapper = car__other.find(".quote-question"),
			car__other_select = car__other.find("select[name=car__other]");

		// hide the dropdown by default.
		car__other.hide();

		// toggle inner question based on input change.
		car__other_toggle.on("change", function () {
			if ($(this).val() == "true") {
				car__other.show();

				car__other_select.addClass("skip");
				car__other_wrapper.removeClass("input-status--correct").removeClass("input-status");

				car__other_select.val(null).trigger("change");
				car__other_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.addClass("hidden");

				car__other_select.select2("destroy");
				car__other_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			} else {
				car__other.hide();

				car__other_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.prop("selected", true)
					.removeClass("hidden");
				car__other_select.trigger("change");
			}
		});

		// if the question was prefilled and has a value.
		if ($('input[name="' + car__other_toggle.attr("name") + '"]:checked').val()) {
			if ($('input[name="' + car__other_toggle.attr("name") + '"]:checked').val() == "true") {
				car__other.show();

				car__other_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.addClass("hidden");

				car__other_select.select2("destroy");
				car__other_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			} else {
				car__other.hide();

				car__other_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.prop("selected", true)
					.removeClass("hidden");
				car__other_select.trigger("change");
			}
		}
	}
}

function triggerEmploymentQuestion() {
	if ($("select[name=details__employment]").length) {
		// gather all variables needed.
		var details__employment = $("select[name=details__employment]"),
			parent = details__employment.closest(".quote-question").next(".quote-question--children-wrapper"),
			details__student_type = parent.find(".details__student_type"),
			details__job = parent.find(".details__job"),
			details__job_select = details__job.find("select[name=details__job]"),
			details__industry = parent.find(".details__industry"),
			details__other = parent.find(".details__employment_other"),
			details__other_label__occupation = details__other.find(".quote-question__label #dynamic-occupation"),
			details__other_label__status = details__other.find(".quote-question__label #dynamic-status");

		// hide student type by default.
		details__student_type.hide();

		// toggle inner question based on input change.
		details__employment.on("change", function () {
			var student_val = details__employment
				.find("option")
				.filter(function () {
					// For reference, ID 1 used to be [Student].
					if ($(this).val() == "3") {
						return true;
					}

					return false;
				})
				.val();

			if ($(this).val() == student_val) {
				details__job.hide();
				details__job.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', -1);

				details__industry.hide();
				details__industry.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', -1);

				details__student_type.show();
				details__student_type.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', 0);

				details__other_label__status.html("status as a student");
			} else {
				details__job.show();
				details__job.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', 0);

				details__industry.show();
				details__industry.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', 0);

				details__student_type.hide();
				details__student_type.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', -1);

				details__other_label__status.html("main occupation");
			}
		});

		// if the question was prefilled and has a value.
		if (details__employment.val()) {
			var student_val = details__employment
					.find("option")
					.filter(function () {
						// For reference, ID 1 used to be [Student].
						if ($(this).val() == "3") {
							return true;
						}

						return false;
					})
					.val(),
				current_val = details__employment.val();

			if (student_val == current_val) {
				details__job.hide();
				details__industry.hide();
				details__student_type.show();

				setTimeout(function () {
					details__job.find('select').next('.select2-container').attr('tabindex', -1);
					details__job.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', -1);
					details__industry.find('select').next('.select2-container').attr('tabindex', -1);
					details__industry.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', -1);
					details__student_type.find('select').next('.select2-container').attr('tabindex', 0);
					details__student_type.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', 0);
				}, 500);

				details__other_label__status.html("status as a student");
			} else {
				details__job.show();
				details__industry.show();
				details__student_type.hide();

				setTimeout(function () {
					details__job.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', 0);
					details__job.find('select').next('.select2-container').attr('tabindex', 0);
					details__industry.find('select').next('.select2-container').attr('tabindex', 0);
					details__industry.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', 0);
					details__student_type.find('select').next('.select2-container').attr('tabindex', -1);
					details__student_type.find('select').next('.select2-container').find('.select2-selection').attr('tabindex', -1);
				}, 500);

				details__other_label__status.html("main occupation");
			}
		}
	}
}

function triggerAdditionalDriverOtherVehicleQuestion(parent = false) {
	if ($(".quote-question.details__additional_own_other input[type=radio]").length) {
		// add functionality to handle which is the parent to search and apply the events from within.
		var target = document;
		if (parent) {
			target = parent;
		}

		// gather all variables needed.
		var details__additional_own_other = $(target).find(".quote-question.details__additional_own_other input[type=radio]"),
			parent = details__additional_own_other.closest(".quote-question"),
			details__additional_other_cars = parent.siblings(".quote-question.details__additional_other_cars"),
			details__additional_other_cars_select = details__additional_other_cars.find(".details__additional_other_cars--input");

		// hide the dropdown by default.
		details__additional_other_cars.hide();

		// toggle inner question based on input change.
		details__additional_own_other.on("change", function () {
			if ($(this).val() == "true") {
				details__additional_other_cars.show();

				details__additional_other_cars_select.addClass("skip");
				details__additional_other_cars_select.val(null).trigger("change");
				details__additional_other_cars_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.addClass("hidden");

				details__additional_other_cars_select.select2("destroy");
				details__additional_other_cars_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			} else {
				details__additional_other_cars.hide();

				details__additional_other_cars_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.prop("selected", true)
					.removeClass("hidden");
				details__additional_other_cars_select.trigger("change");
			}
		});

		// if the question was prefilled and has a value.
		if ($('input[name="' + details__additional_own_other.attr("name") + '"]:checked').val()) {
			if ($('input[name="' + details__additional_own_other.attr("name") + '"]:checked').val() == "true") {
				details__additional_other_cars.show();

				details__additional_other_cars_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.addClass("hidden");

				details__additional_other_cars_select.select2("destroy");
				details__additional_other_cars_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			} else {
				details__additional_other_cars.hide();

				details__additional_other_cars_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.prop("selected", true)
					.removeClass("hidden");
				details__additional_other_cars_select.trigger("change");
			}
		}
	}
}

function addonBreakdownSelection() {
	// add functionality for [Addon - Breakdown] selection on [Quote Results] stage.
	if ($("input[name^=quote-addons].category--Breakdown").length) {
		var breakdownInputs = $("input[name^=quote-addons].category--Breakdown");

		breakdownInputs.on("change", function (e) {
			e.preventDefault();

			var isChecked = $(this).prop("checked");

			if (isChecked) {
				// Uncheck all other checkboxes
				breakdownInputs.not(this).prop("checked", false);
			}

			var length = $(this).closest(".quote__option-wrapper").attr("data-quote-length");
			getNewQuoteResults(length, null, true);
		});
	}

	// add functionality for [Addon (excluding Breakdowns)] selection on [Your Addons] stage.
	if ($(".quote-question__radios-inputs input[type=radio]").length) {
		$(".quote-question__radios-inputs input[type=radio]").on("change", function () {
			var parent = $(this).closest(".quote__option-addon_content");

			if (parent.length) {
				var inputName = $(this).attr("name");
				var inputVal = $('input[name="' + inputName + '"]:checked').val();

				if (inputVal == "true") {
					parent.addClass("active");
				} else {
					parent.removeClass("active");
				}

				if (!parent.hasClass('quote__option-breakdown"')) {
					
					var addon = $(parent).find('input[name^=quote-addons]');

					if (inputVal == "true") {
						addon.prop("checked", true);
					} else {
						addon.prop("checked", false);
					}
				}
			}
		});
	}

	// add functionality for [Addon - Breakdowns] selection on [Your Addons] stage.
	if ($(".quote-question__breakdown #breakdown").length) {
		var breakdowns = $(".quote-question__breakdown #breakdown"),
			inputs = breakdowns.siblings("input");

		if (breakdowns.length && inputs.length) {
			breakdowns.on("change", function () {
				var inputVal = $(this).val();
				var inputId = "input#quote__option-addon-" + inputVal;

				for (let i = 0; i < inputs.length; i++) {
					$(inputs[i]).prop("checked", false);
				}

				$(inputId).prop("checked", true);
			});
		}
	}
}

function triggerAdditionalDriverEmploymentQuestion(parent = false) {
	if ($(".quote-question.details__additional_employment .quote-question--select").length) {
		// add functionality to handle which is the parent to search and apply the events from within.
		var target = document;
		if (parent) {
			target = parent;
		}

		// gather all variables needed.
		var details__additional_employment = $(target).find(".quote-question.details__additional_employment .quote-question--select"),
			parent = details__additional_employment.closest(".quote-question").next(".quote-question--children-wrapper"),
			details__additional_student_type = parent.find(".details__additional_student_type"),
			details__additional_employment_job = parent.find(".details__additional_employment_job"),
			details__additional_employment_industry = parent.find(".details__additional_employment_industry");

		// hide student type by default.
		details__additional_student_type.hide();

		// toggle inner question based on input change.
		details__additional_employment.on("change", function () {
			var student_val = details__additional_employment
				.find("option")
				.filter(function () {
					// For reference, ID 1 used to be [Student].
					if ($(this).val() == "3") {
						return true;
					}

					return false;
				})
				.val();

			if ($(this).val() == student_val) {
				details__additional_employment_job.hide();
				details__additional_employment_industry.hide();
				details__additional_student_type.show();
			} else {
				details__additional_employment_job.show();
				details__additional_employment_industry.show();
				details__additional_student_type.hide();
			}
		});

		// if the question was prefilled and has a value.
		if (details__additional_employment.val()) {
			var student_val = details__additional_employment
					.find("option")
					.filter(function () {
						// For reference, ID 1 used to be [Student].
						if ($(this).val() == "3") {
							return true;
						}

						return false;
					})
					.val(),
				current_val = details__additional_employment.val();
			if (student_val == current_val) {
				details__additional_employment_job.hide();
				details__additional_employment_industry.hide();
				details__additional_student_type.show();
			} else {
				details__additional_employment_job.show();
				details__additional_employment_industry.show();
				details__additional_student_type.hide();
			}
		}
	}
}

function triggerMedicalConditionQuestion() {
	if ($(".quote-question.details__conditions_boolean input[type=radio]").length) {
		// gather all variables needed.
		var details__conditions_boolean = $(".quote-question.details__conditions_boolean input[type=radio]"),
			parent = details__conditions_boolean.closest(".quote-question"),
			details__conditions = parent.siblings(".quote-question--medicalConditions"),
			details__conditions_select = details__conditions.find(".details__conditions--input");

		// hide medical conditions by default.
		details__conditions.hide();

		// toggle inner question based on input change.
		details__conditions_boolean.on("change", function () {
			if ($(this).val() == "true") {
				details__conditions.show();

				details__conditions_select.addClass("skip");

				details__conditions_select.val(null).trigger("change");
				details__conditions_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.addClass("hidden");

				details__conditions_select.select2("destroy");
				details__conditions_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			} else {
				details__conditions.hide();

				details__conditions_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.prop("selected", true)
					.removeClass("hidden");

				details__conditions_select.trigger("change");

				details__conditions_select.select2("destroy");
				details__conditions_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			}
		});

		// if the question was prefilled and has a value.
		if ($('input[name="' + details__conditions_boolean.attr("name") + '"]:checked').val()) {
			if ($('input[name="' + details__conditions_boolean.attr("name") + '"]:checked').val() == "true") {
				details__conditions.show();

				details__conditions_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.addClass("hidden");

				details__conditions_select.select2("destroy");
				details__conditions_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			} else {
				details__conditions.hide();

				details__conditions_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.prop("selected", true)
					.removeClass("hidden");

				details__conditions_select.trigger("change");

				details__conditions_select.select2("destroy");
				details__conditions_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			}
		} else {
			details__conditions.hide();

			details__conditions_select
				.find("option")
				.filter(function () {
					if ($(this).text()) {
						if ($(this).text().toLowerCase() == "no") {
							return true;
						}
					}

					return false;
				})
				.prop("selected", true)
				.removeClass("hidden");

			details__conditions_select.trigger("change");

			details__conditions_select.select2("destroy");
			details__conditions_select.select2({
				minimumResultsForSearch: 7,
				placeholder: "- Select -",
				templateResult: function (state) {
					let $option = $(state.element);
					if ($option.hasClass("hidden")) {
						return null;
					}
					return state.text;
				},
			});
		}
	}
}

function inputToUppercase(parent) {
	var target = document;
	if (parent) {
		target = parent;
	}

	$(target)
		.find(".to-uppercase")
		.on("input", function () {
			var value = $(this).val().toUpperCase();
			$(this).val(value);
		});
}

function triggerConvictionCodeQuestion(target = false) {
	var details__convictions_type = "";
	if (target) {
		details__convictions_type = target.find(".quote-question.details__convictions_type .quote-question--select");
	} else if ($(".details__convictions_type").length) {
		details__convictions_type = $(".quote-question.details__convictions_type .quote-question--select");
	}

	if (details__convictions_type.length) {
		details__convictions_type.each(function () {
			var parent = $(this).closest(".quote-question"),
				details__convictions_code = parent.siblings(".details__convictions_code").find(".quote-question--select");

			$(this).on("change", function () {
				var selected_conviction_type = $(this).val();

				details__convictions_code.addClass("skip");
				details__convictions_code.val(null).trigger("change");
				details__convictions_code.find("option.hidden").removeClass("hidden");
				details__convictions_code
					.find("option")
					.filter(function () {
						return $(this).data("conviction-type") != selected_conviction_type;
					})
					.addClass("hidden");

				details__convictions_code.select2("destroy");
				details__convictions_code.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			});
		});
	}
}

function triggerAdditionalDriverConvictionCodeQuestion(parent = false) {
	if (parent) {
		var details__additional_convictions_type = $(parent).find(".quote-question.details__additional_convictions_type .quote-question--select"),
			parent = details__additional_convictions_type.closest(".quote-question"),
			details__additional_convictions_code = parent.siblings(".details__additional_convictions_code").find(".quote-question--select");
	} else {
		var details__additional_convictions_type = $(document).find(".quote-question.details__additional_convictions_type .quote-question--select"),
			parent = details__additional_convictions_type.closest(".quote-question"),
			details__additional_convictions_code = parent.siblings(".details__additional_convictions_code").find(".quote-question--select");
	}

	details__additional_convictions_type.on("change", function () {
		var selected_conviction_type = $(this).val();

		details__additional_convictions_code.val(null).trigger("change");
		details__additional_convictions_code.find("option.hidden").removeClass("hidden");
		details__additional_convictions_code
			.find("option")
			.filter(function () {
				return $(this).data("conviction-type") != selected_conviction_type;
			})
			.addClass("hidden");

		details__additional_convictions_code.select2("destroy");
		details__additional_convictions_code.addClass("skip");
		details__additional_convictions_code.val(null).trigger("change");
		details__additional_convictions_code.select2({
			minimumResultsForSearch: 7,
			placeholder: "- Select -",
			templateResult: function (state) {
				let $option = $(state.element);
				if ($option.hasClass("hidden")) {
					return null;
				}
				return state.text;
			},
		});
	});
}

function triggerAdditionalDriverMedicalConditionQuestion(parent = false) {
	if (parent) {
		var details__additional_conditions_boolean = $(parent).find(".quote-question.details__additional_conditions_boolean input[type=radio]"),
			parent = details__additional_conditions_boolean.closest(".quote-question"),
			details__additional_conditions = parent.next(".details__additional_conditions"),
			details__additional_conditions_select = details__additional_conditions.find(".details__additional_conditions--input");
	} else {
		var details__additional_conditions_boolean = $(document).find(".quote-question.details__additional_conditions_boolean input[type=radio]"),
			parent = details__additional_conditions_boolean.closest(".quote-question"),
			details__additional_conditions = parent.next(".details__additional_conditions"),
			details__additional_conditions_select = details__additional_conditions.find(".details__additional_conditions--input");
	}

	// hide medical conditions by default.
	details__additional_conditions.hide();

	// toggle inner question based on input change.
	details__additional_conditions_boolean.each(function() {
		$(this).on("change", function() {
			var parent = $(this).closest(".quote-question"),
				details__additional_conditions = parent.next(".details__additional_conditions"),
				details__additional_conditions_select = details__additional_conditions.find(".details__additional_conditions--input");

			if ($(this).val() == "true") {
				details__additional_conditions.show();

				details__additional_conditions_select.addClass("skip");

				details__additional_conditions_select.val(null).trigger("change");
				details__additional_conditions_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.addClass("hidden");

				details__additional_conditions_select.select2("destroy");
				details__additional_conditions_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			} else {
				details__additional_conditions.hide();

				details__additional_conditions_select
					.find("option")
					.filter(function () {
						if ($(this).text()) {
							if ($(this).text().toLowerCase() == "no") {
								return true;
							}
						}

						return false;
					})
					.prop("selected", true)
					.removeClass("hidden");

				details__additional_conditions_select.trigger("change");

				details__additional_conditions_select.select2("destroy");
				details__additional_conditions_select.select2({
					minimumResultsForSearch: 7,
					placeholder: "- Select -",
					templateResult: function (state) {
						let $option = $(state.element);
						if ($option.hasClass("hidden")) {
							return null;
						}
						return state.text;
					},
				});
			}
		});
	});

	// if the question was prefilled and has a value.
	if ($('input[name="' + details__additional_conditions_boolean.attr("name") + '"]:checked').val()) {
		if ($('input[name="' + details__additional_conditions_boolean.attr("name") + '"]:checked').val() == "true") {
			details__additional_conditions.show();

			details__additional_conditions_select
				.find("option")
				.filter(function () {
					if ($(this).text()) {
						if ($(this).text().toLowerCase() == "no") {
							return true;
						}
					}

					return false;
				})
				.addClass("hidden");

			details__additional_conditions_select.select2("destroy");
			details__additional_conditions_select.select2({
				minimumResultsForSearch: 7,
				placeholder: "- Select -",
				templateResult: function (state) {
					let $option = $(state.element);
					if ($option.hasClass("hidden")) {
						return null;
					}
					return state.text;
				},
			});
		} else {
			details__additional_conditions.hide();

			details__additional_conditions_select
				.find("option")
				.filter(function () {
					if ($(this).text()) {
						if ($(this).text().toLowerCase() == "no") {
							return true;
						}
					}

					return false;
				})
				.prop("selected", true)
				.removeClass("hidden");

			details__additional_conditions_select.trigger("change");

			details__additional_conditions_select.select2("destroy");
			details__additional_conditions_select.select2({
				minimumResultsForSearch: 7,
				placeholder: "- Select -",
				templateResult: function (state) {
					let $option = $(state.element);
					if ($option.hasClass("hidden")) {
						return null;
					}
					return state.text;
				},
			});
		}
	} else {
		details__additional_conditions.hide();

		details__additional_conditions_select
			.find("option")
			.filter(function () {
				if ($(this).text()) {
					if ($(this).text().toLowerCase() == "no") {
						return true;
					}
				}

				return false;
			})
			.prop("selected", true)
			.removeClass("hidden");

		details__additional_conditions_select.trigger("change");

		details__additional_conditions_select.select2("destroy");
		details__additional_conditions_select.select2({
			minimumResultsForSearch: 7,
			placeholder: "- Select -",
			templateResult: function (state) {
				let $option = $(state.element);
				if ($option.hasClass("hidden")) {
					return null;
				}
				return state.text;
			},
		});
	}
}

function triggerQuoteResultsTabs() {
	if ($(".display-quote__tabs").length) {
		var input = $("input[name=display_quote]");

		// if no tab is preselected (e.g. the first quote was declined and rendered no tab), fall back to the first rendered tab so a card body always shows.
		if (input.length && !input.filter(":checked").length) {
			input.first().prop("checked", true);
		}

		var target = ".quote__option-wrapper--" + $("input[name=display_quote]:checked").val();

		$(target).addClass("active");

		input.on("change", function () {
			var target = ".quote__option-wrapper--" + $(this).val();

			$(".quote__option-wrapper.active").removeClass("active");
			$(target).addClass("active");
			quoteResultsStartDate = $('.quote__option-wrapper.active .quote__option-period .start-date').val();
		});
	}
}

function disableScrolling() {
	var x = window.scrollX;
	var y = window.scrollY;

	window.onscroll = function () {
		window.scrollTo(x, y);
	};
}

function enableScrolling() {
	window.onscroll = function () {};
}

function popupToggleScroll() {
	$(document).on("lity:open", function (event, instance) {
		disableScrolling();
	});

	$(document).on("lity:close", function (event, instance) {
		enableScrolling();
	});
}

function checkDateInputs(parent = false) {
	if (parent) {
		var dates = $(parent).find("input.is-date");
	} else {
		var dates = $(document).find("input.is-date");
	}

	$.each(dates, function (index, date) {
		if ($(date).val() && !$(date).val().includes("dd/mm/yyyy")) {
			$(date).addClass("has-value");
		} else {
			$(date).removeClass("has-value");
		}

		$(date).on("change", function () {
			if ($(this).val() && !$(this).val().includes("dd/mm/yyyy")) {
				$(this).addClass("has-value");
			} else {
				$(date).removeClass("has-value");
			}
		});
	});
}

function aggregatorDetailsCorrect() {
	if ($(".quote-question.details__aggregator_correct input[type=radio]").length) {
		// gather all variables needed.
		var details__aggregator_correct = $(".quote-question.details__aggregator_correct input[type=radio]");

		details__aggregator_correct.on("change", function () {
			if ($(this).val() == "false") {
				var redirect = "/quote/your-car/?aggregator=true&details-incorrect=true";
				window.location.href = redirect;
			}
		});
	}
}

function aggregatorDeclarationDetailsCorrect() {
	if ($(".quote-question.aggregator-declaration input[type=radio]").length) {
		// gather all variables needed.
		var details__aggregator_correct = $(".quote-question.aggregator-declaration input[type=radio]");

		details__aggregator_correct.on("change", function () {
			if ($(this).val() == "false") {
				// disable [Next] button.
				$('button[name=go-forward-stage--aggregator-declaration]').addClass('disabled');

				// redirect users back at the beginning.
				var redirect = "/quote/your-car/?aggregator=true&details-incorrect=true";
				window.location.href = redirect;
			} else {
				$('button[name=go-forward-stage--aggregator-declaration]').removeClass('disabled');
			}
		});
	}
}

function inputNumberKeyboard() {
	$(document).on("keyup", "input[type=number]", function (event) {
		event.preventDefault();

		let step = $(this).data("step") ? parseInt($(this).data("step"), 10) : 0;
		let value = parseInt($(this).val(), 10);
		let newValue = 0;

		if (event.keyCode === 38) {
			newValue = Math.round((value + step) / 1000) * 1000;

			if (step) {
				$(this).val(newValue);
			}
		} else if (event.keyCode == 40) {
			newValue = Math.round((value - step) / 1000) * 1000;

			if (newValue < 0) {
				newValue = 0;
			}

			if (step) {
				$(this).val(newValue);
			}
		}
	});
}

function triggerPaymentError() {
	if ($("#payment-fail-button").length) {
		$("#payment-fail-button").trigger("click");
	}
}

function triggerAggregatorError() {
	if ($("#aggregator-fail-button").length) {
		$("#aggregator-fail-button").trigger("click");
	}
}

function newCarRegClearQuestions() {
	if ($(".quote-question__car-reg").length) {
		$(document).on("click", "#car-incorrect", function () {
			// Select the target element.
			var targetElement = $(".quote-car");

			// Create a new instance of MutationObserver.
			var observer = new MutationObserver(function (mutations) {
				mutations.forEach(function (mutation) {
					// if the mutation that happened was for a class, and that class was "active".
					if (mutation.attributeName === "class" && $(mutation.target).hasClass("active")) {
						// Find all inner input elements and clear their values.
						$(targetElement)
							.find('input[type="text"], input[type="number"], input[type="radio"], input[type="checkbox"], select, .quote-question__boolean-btn.active, .quote-question--sub')
							.each(function () {
								// Clear the value of text and select elements.
								if ($(this).is('input[type="text"]:not(".car__manual_car_registration--input"), input[type="number"], select')) {
									$(this).addClass("skip");
									$(this).val("").trigger("change");
									$(this).next(".price_formatted").remove();
								} else {
									// if this is an active button
									if ($(this).hasClass("active")) {
										$(this).removeClass("active");
									} else {
										// if this is an active [sub-question].
										if ($(this).hasClass("quote-question--sub")) {
											$(this).hide();
										} else {
											$(this).addClass("skip");
											// Uncheck radio and checkbox elements.
											$(this).prop("checked", false).trigger("change");
										}
									}
								}
							});
					}
				});
			});

			// Configure the MutationObserver to watch for attribute changes
			var config = { attributes: true };

			// Start observing the target element for changes
			for (let i = 0; i < targetElement.length; i++) {
				observer.observe(targetElement[i], config);
			}
		});
	}
}

function getYearsPassed(date) {
	// Current date
	var currentDate = new Date();

	// Calculate the difference in milliseconds between the dates
	var timeDifference = currentDate - date;

	// Convert milliseconds to years
	var millisecondsPerYear = 1000 * 60 * 60 * 24 * 365.25; // considering leap years
	var yearsPassed = Math.floor(timeDifference / millisecondsPerYear);

	return yearsPassed;
}

function prefillDateInput(parent = false) {
	// add functionality to handle which is the parent to search and apply the events from within.
	var target = document;
	if (parent) {
		target = parent;
	}

    $(target).find('input[type=text].is-date').on('input', function () {
        let format = $(this).data('format') || 'd/m/Y';
        let parts = format.split('/');
        let lengths = [];
        for (let part of parts) {
            if (part.toLowerCase().includes('y')) {
                lengths.push(part.length === 1 ? 2 : 4);
            } else {
                lengths.push(2);
            }
        }
        let value = $(this).val().replace(/\D/g, '');
        let formatted = '';
        let pos = 0;
        for (let i = 0; i < lengths.length; i++) {
            let len = lengths[i];
            if (pos < value.length) {
                let take = Math.min(len, value.length - pos);
                formatted += value.slice(pos, pos + take);
                pos += take;
                if (i < lengths.length - 1 && pos < value.length) {
                    formatted += '/';
                }
            }
        }
        $(this).val(formatted);
    });
}

function calculateDOBYears(parent = false) {
	// add functionality to handle which is the parent to search and apply the events from within.
	var target = document;
	if (parent) {
		target = parent;
	}

	if (target.length) {
		let dob = target.val();

		if (dob) {
			return getYearsPassed(parseUKDate(dob));
		}
	}

	return false;
}

function resetTotalUKTime(target, years) {
	if (target.length) {
		var previousValue = target.val();
		
		// reset all hidden options.
		target.find("option.hidden").removeClass("hidden");
		target.val(null).trigger("change");

		// calculate what options need to be hidden.
		target
			.find("option")
			.filter(function () {
				if ($(this).val()) {
					if (parseInt($(this).val(), 10) >= years) {
						return true;
					}
				}

				return false;
			})
			.addClass("hidden");

		// re-generate select2 and skip hidden options.
		target.select2("destroy");
		target.select2({
			minimumResultsForSearch: -1,
			placeholder: "- Select -",
			templateResult: function (state) {
				let $option = $(state.element);
				if ($option.hasClass("hidden")) {
					return null;
				}
				return state.text;
			},
		});

		target.val(previousValue).trigger("change");
	}
}

function calculateTotalUKTime() {
	// if the main question needed to calculate the total time in the UK exists.
	if ($(".details__lived").length) {
		// attach a change event listener to the main question.
		$("input[name=details__lived]").on("change", function () {
			// if there's a DOB question on the same page.
			if ($("input[name=details__birth]").length) {
				// if the question is supposed to open the inner question.
				if ($(this).val() == "no") {
					let years = calculateDOBYears($("input[name=details__birth]"));

					if (years && $("select[name=details__moved-years]").length) {
						let target = $("select[name=details__moved-years]");

						resetTotalUKTime(target, years);
					}
				}
			}
		});

		// attach a change event listener to the DOB question.
		$("input[name=details__birth]").on("change", function () {
			let years = calculateDOBYears($("input[name=details__birth]"));
			let dob = $("input[name=details__birth]").val();

			// set a new limit for all convictions date to be less than customer's age.
			if($('.details__convictions_when .quote-question__input-wrapper input')) {
				$('.details__convictions_when .quote-question__input-wrapper input').attr('data-min', dob);
			}

			// set a new limit for all accidents date to be less than customer's age.
			if($('.details__motor_when .quote-question__input-wrapper input')) {
				$('.details__motor_when .quote-question__input-wrapper input').attr('data-min', dob);
			}

			// if there's a DOB set and the question is supposed to open the inner question.
			if (!$("input[name=details__lived]:checked").length || $("input[name=details__lived]:checked").val() == "no") {
				// calculate years and update it for a max limit for total UK time.
				if (years && $("select[name=details__moved-years]").length) {
					let targetUKMovedYears = $("select[name=details__moved-years]");

					resetTotalUKTime(targetUKMovedYears, years);
				}
			}

			// calculate years and update it for a max limit for total licence length time.
			if(years && $("select[name=details__license_length-years]").length) {
				let targetLicenceLength = $("select[name=details__license_length-years");
			
				resetTotalUKTime(targetLicenceLength, years);
			}
		});

		// if the main question is already toggled and the inner question is displayed.
		if ($("input[name=details__lived]:checked").val()) {
			// if there's a DOB question on the same page.
			if ($("input[name=details__birth]").length) {
				// if there's a DOB set and the question is supposed to open the inner question.
				if (
					(!$("input[name=details__lived]:checked").length || $("input[name=details__lived]:checked").val() == "no") && 
					(!$("input[name=details__lived]:checked").closest('.quote-question').hasClass('readonly'))
				) {
					let years = calculateDOBYears($("input[name=details__birth]"));

					// calculate years and update it for a max limit for when customer moved to the UK.
					if (years && $("select[name=details__moved-years]").length) {
						let target = $("select[name=details__moved-years]");

						resetTotalUKTime(target, years);
					}
				}
			}
		}
	}
}

function additionalDriverCalculateTotalUKTime(parent = false) {
	// add functionality to handle which is the parent to search and apply the events from within.
	var target = document;
	if (parent) {
		target = parent;
	}

	// gather all variables needed.
	var details__additional_birth = $(target).find(".quote-question.details__additional_birth .quote-question__input");

	details__additional_birth.each(function() {
		var currentParent = $(this).closest(".quote-question--children"),
			details__additional_moved = currentParent.find(".details__additional_moved"),
			details__additional_moved_select = details__additional_moved.find(".quote-question--select"),
			details__additional_lived = currentParent.find(".details__additional_lived"),
			details__additional_license_length = currentParent.find(".details__additional_license_length"),
			details__additional_license_length_select = details__additional_license_length.find(".quote-question--select"),
			details__additional_motor_when = currentParent.find(".details__additional_motor_when"),
			details__additional_convictions_when = currentParent.find(".details__additional_convictions_when");

		// attach a change event listener to the main question.
		details__additional_lived.find('input[type=radio]').on("change", function () {
			// if the question is supposed to open the inner question.
			if ($(this).val() == "no") {
				let years = calculateDOBYears($(this));

				if (years && details__additional_moved_select.length) {
					let target = details__additional_moved_select;

					resetTotalUKTime(target, years);
				}
			}
		});

		// attach a change event listener to the DOB question.
		$(this).on("change", function () {
			let years = calculateDOBYears($(this));
			let dob = $(this).val();

			// set a new limit for all convictions date to be less than customer's age.
			if(details__additional_convictions_when.find('.quote-question__input-wrapper input').length) {
				details__additional_convictions_when.find('.quote-question__input-wrapper input').attr('data-min', dob);
			}

			// set a new limit for all accidents date to be less than customer's age.
			if(details__additional_motor_when.find('.quote-question__input-wrapper input').length) {
				details__additional_motor_when.find('.quote-question__input-wrapper input').attr('data-min', dob);
			}

			// if there's a DOB set and the question is supposed to open the inner question.
			if (!details__additional_lived.find('input[type=radio]:checked').length || details__additional_lived.find('input[type=radio]:checked').val() == "no") {
				// calculate years and update it for a max limit for when customer moved to the UK.
				if (years && details__additional_moved_select.length) {
					let targetUKMovedYears = details__additional_moved_select;

					resetTotalUKTime(targetUKMovedYears, years);
				}
			}

			if(years && details__additional_license_length_select.length) {
				let targetLicenceLength = details__additional_license_length_select;

				// calculate years and update it for a max limit for total licence length time.
				resetTotalUKTime(targetLicenceLength, years);
			}
		});

		if((!details__additional_lived.find('input[type=radio]:checked').length || details__additional_lived.find('input[type=radio]:checked').val() == "no") && !details__additional_lived.hasClass('readonly')) {
			let years = calculateDOBYears($(this));

			if (years && details__additional_moved_select.length) {
				let targetUKMovedYears = details__additional_moved_select;

				// calculate years and update it for a max limit for when customer moved to the UK.
				resetTotalUKTime(targetUKMovedYears, years);
			}
		}
	});
}

function triggerQuoteGoBack() {
	if ($(".btn--back").length) {
		$(".btn--back").click(function (e) {
			if ($(this).attr("href") === "#") {
				e.preventDefault();

				let previousPage = document.referrer,
			 	aggregator = getCookieValue("aggregator"),
			 	aggregator_data = getCookieValue("aggregator_data");

				if($(this).hasClass('payment')) {
					if (history.length > 2) {
						let historyList = JSON.parse(localStorage.getItem('pageHistory')) || [];

						// Step 1: Reverse the array
						let reversedHistory = [...historyList].reverse();

						// Step 2: Find the first matching URL
						let match = reversedHistory.find(item => {
							return item.url.includes('/my-account/') || item.url.includes('/quote/policy-information/');
						});

						// Step 3: Redirect
						window.location.href = match.url;
					}
				} else {
					let previousPageURL = '';

					if (previousPage.includes("my-account")) {
						previousPageURL = document.referrer;
					} else if (previousPage.includes("quote")) {
						if (previousPage.includes("policy-information")) {
							let queryString = window.location.search,
								yourPolicyPage = document.location.origin + "/quote/multi-product/" + queryString;

								if(aggregator && aggregator_data) {
									yourPolicyPage = document.location.origin + "/quote/your-details/" + queryString;
								}
	
								previousPageURL = yourPolicyPage;
						} else {
							previousPageURL = document.referrer;
						}
					} else if (previousPage.includes("pay/start")) {
						let queryString = window.location.search,
						yourPolicyPage = document.location.origin + "/quote/quote-results/" + queryString;
	
						previousPageURL = yourPolicyPage;
					}

					window.location.href = previousPageURL;
				}
			}
		});
	}
}

function triggerDocument(currentItem) {
	var animPromise,
		ajaxPromise,
		pathArray = location.href.split("/"),
		protocol = pathArray[0],
		host = pathArray[2],
		ajax_url = protocol + "//" + host + "/wp-admin/admin-ajax.php";

	currentItem.addClass("disabled");
	currentItem.find(".c__loader").addClass("active");

	var link = currentItem;
	var type = currentItem.data("type");
	var policy = currentItem.data("policy") ? currentItem.data("policy") : currentItem.data("addons");

	if (type) {
		animPromise = wait();
		ajaxPromise = $.ajax({
			type: "POST",
			url: ajax_url,
			data: {
				action: "mw_collingwood_create_doc",
				type: type,
				policy: policy,
			},
			xhrFields: {
				responseType: "blob",
			},
			success: function (data) {
				if (data.constructor.name == "Blob") {
					try {
						if (isSafari) {
							var a = document.createElement("a");
							var url = window.URL.createObjectURL(data);

							a.href = url;
							a.download = type + ".pdf";
							document.body.append(a);
							a.click();
							a.remove();
						} else {
							var url = window.URL.createObjectURL(data);
							window.open(url, "_blank");
						}
					} catch (error) {
						try {
							var a = document.createElement("a");
							var url = window.URL.createObjectURL(data);

							a.href = url;
							a.download = type + ".pdf";
							document.body.append(a);
							a.click();
							a.remove();
						} catch (error) {
							console.error("An error occurred: ", error.message);
							alert("Unable to open document");
						}
					}
				} else {
					alert("Unable to open document");
				}
			},
			error: function () {
				alert("Unable to open document");
			},
		});
		$.when(animPromise, ajaxPromise).done(function () {
			link.removeClass("disabled");
			link.find(".c__loader").removeClass("active");
		});
	}
}

function attachPolicyInformationDataAttributes() {
	let policyInformationDocuments = $(document).find(".document--insurance-product-information, .document--policy, .document--terms-of-business");

	if (policyInformationDocuments.length) {
		let policyData = policyInformationDocuments.closest(".quote__option-addons").data("policy"),
			loader = '<div class="c__loader small c__loader--dark"><div></div><div></div><div></div><div></div></div>';

		policyInformationDocuments.each(function () {
			$(this).attr("data-policy", policyData);
			$(this).append(loader);

			let currentClass = $(this).attr("class");

			switch (currentClass) {
				case "document--insurance-product-information":
					$(this).attr("data-type", "IPID");
					$(this).removeClass('document--insurance-product-information');
					$(this).addClass('a__link').addClass('a__link--document');

					break;

				case "document--policy":
					$(this).attr("data-type", "PolicyDocument");
					$(this).removeClass('document--policy');
					$(this).addClass('a__link').addClass('a__link--document');

					break;

				case "document--terms-of-business":
					$(this).attr("data-type", "TermsOfBusiness");
					$(this).removeClass('document--terms-of-business');
					$(this).addClass('a__link').addClass('a__link--document');

					break;
			}

			$(this).on("click", function (e) {
				e.preventDefault();

				triggerDocument($(this));
			});
		});
	}
}

function triggerNumberPreFormat() {
	$("body").on("click", ".price_formatted", function () {
		$(this).siblings('input[type="number"]').focus();
		$(this).remove();
	});

	$("#car__worth, #car__drive").on("focusout", function () {
		if ($(this).val()) {
			$(this).next(".price_formatted").remove();
			var val = formatPrice($(this).val());
			var formatVal = parseInt($(this).val());
			$(this).val(formatVal);
			$(this).after('<span class="price_formatted">' + val + "</span>");
		}
	});
}

function addDynamicDropdown() {
	// Define a list of category/parent => type/child classes to be used to enable dynamic dropdown selection.
	const dynamicDropdowns = [
		{
			category: ".car__modifications_category",
			type: ".car__modifications_type",
		},
		{
			category: ".details__motor_what",
			type: ".details__motor_type",
		},
		{
			category: ".details__additional_motor_what",
			type: ".details__additional_motor_type",
		},
	];

	// Look through all classes defined above and enable the functionality.
	for (let i = 0; i < dynamicDropdowns.length; i++) {
		recalculateDropdowns(dynamicDropdowns[i]["category"], dynamicDropdowns[i]["type"]);
	}
}

function triggerImportantPolicyCheckboxes() {
	$(".policy__legal-checkbox--important input[type=checkbox]").on("change", function () {
		var parent = $(this).closest(".quote__option-addon_content");

		if (parent.length) {
			var c = parent.find(".policy__legal-checkbox--important input[type=checkbox]");
			if (c.length == c.filter(":checked").length) {
				parent.addClass("active");
			} else {
				parent.removeClass("active");
			}
		}
	});
}

function ajaxValidateReferralCode() {
	if ($("input[name=about__discount]").length) {
		var discount = $("input[name=about__discount]");

		discount.on("blur", function () {
			var animPromise,
				ajaxPromise,
				pathArray = location.href.split("/"),
				protocol = pathArray[0],
				host = pathArray[2],
				ajax_url = protocol + "//" + host + "/wp-admin/admin-ajax.php",
				result,
				parent = $(this).closest('.quote-question'),
				target = parent.find('.quote-question__input-wrapper'),
				currentInput = $(this);

			if ($.trim($(this).val()).length > 0) {
				parent.addClass('loading');

				animPromise = wait();
				ajaxPromise = $.ajax({
					type: "POST",
					url: ajax_url,
					dataType: "json",
					data: {
						action: "mw_ajax_validate_discount",
						discount: $(this).val(),
					},
					success: function (data) {
						result = data;
					},
					error: function (xhr, status, error) {
						console.error("Error occurred during AJAX request - status code:", xhr.status);
						console.error("Error occurred during AJAX request - message:", error);
					},
					complete: function () {
						window.mwConsoleLog("AJAX request complete.");
					},
				});
				$.when(animPromise, ajaxPromise).done(function () {
					parent.removeClass("loading");

					if(result.success) {
						currentInput.removeClass('error-input');
						parent.removeClass('input-status--incorrect').addClass('input-status').addClass('input-status--correct');
						
						target.addClass('readonly');
						currentInput.addClass('readonly');
						currentInput.prop('readonly', true);
						target.find('.edit').removeClass('hidden');
						
						if(result.message) {
							// keep this line in case we want to revert to actual message.
							// parent.find('.ajax-response').html(result.message); 
							parent.find('.ajax-response').html('Your code has been confirmed');
							parent.find('.ajax-response').removeClass('validation_error').addClass('validation_success');
						}
					} else {
						currentInput.addClass('error-input');
						parent.removeClass('input-status--correct').addClass('input-status').addClass('input-status--incorrect');

						parent.find('.ajax-response').html('There has been an issue validating this referral code, please try again or contact us');
						parent.find('.ajax-response').removeClass('validation_success').addClass('validation_error');
					}
				});
			}
		});
	}
}

function toggleAccountEditableFields() {
    if($('.editable').length) {
        var toggle = $('.editable').find('.edit');

        toggle.on('click', function() {
            var inputs = $(this).siblings('input');

            inputs.prop('readonly', false);
            $(this).parent().removeClass('readonly');
            $(this).addClass('hidden');
			$(this).siblings('.ajax-response').html('');
			$(this).siblings('.ajax-response').removeClass('validation_error').removeClass('validation_success');
        });
    }
}

function triggerLoadingOnSubmit() {
	if($('.trigger-loading').length) {
		$('.trigger-loading').on('click', function() {
			$(this).closest('.popup__inner').addClass('loading');
		});
	}
}

function submitQuoteStartForm() {
	if($('.quote-card-link.submit-form').length) {
		var submitForm = $('.quote-card-link.submit-form');

		submitForm.on('click', function(e) {
			e.preventDefault();

			$(this).closest('.quote-form').trigger('submit');
		});
	}
}

function resolveQueryPolicyButtons() {
	$(document).on('click', '.query-policy', function(e) {
		e.preventDefault();

		var animPromise,
		ajaxPromise,
		pathArray = location.href.split("/"),
		protocol = pathArray[0],
		host = pathArray[2],
		ajax_url = protocol + "//" + host + "/wp-admin/admin-ajax.php",
		policyID = $(this).data('policy-id'),
		currentButton = $(this);

		if(policyID) {
			animPromise = wait();
			ajaxPromise = $.ajax({
				type: "POST",
				url: ajax_url,
				dataType: "json",
				data: {
					action: "mw_ajax_retrieve_policy",
					policyID: policyID,
				},
				success: function (data) {
					result = data;
				},
				error: function (xhr, status, error) {
					console.error("Error occurred during AJAX request - status code:", xhr.status);
					console.error("Error occurred during AJAX request - message:", error);
				},
				complete: function () {
					window.mwConsoleLog("AJAX request complete.");
				},
			});
			$.when(animPromise, ajaxPromise).done(function () {
				if(result.success) {
					let policyData = JSON.parse(result.data);

					currentButton.attr('data-lity', "");


					// TODO: keep the below for reference
					// if the below is a short term extension, show popup automatically
					// if(policyData.PolicyDefinition.Policy.ProductClassID == 1) {
					// 	currentButton.attr('data-lity', "");
					// } else {
					// 	if(policyData.HideNewQuestions) {
					// 		currentButton.addClass('hide-new-question');
					// 	} else {
					// 		currentButton.attr('data-lity', "");
					// 	}
					// }

					if(policyData.HideAccidentConfirmation) {
						currentButton.addClass('hide-accident-confirmation');
					}

					currentButton.removeClass('query-policy');

					currentButton.trigger('click');
				}
			});
		}
	});
}

function toggleAdditionalDriverConfirmQuestion() {
	if ($(".quote-question.details__additional_drivers input[type=radio]").length) {
		// gather all variables needed.
		var details__additional_drivers = $(".quote-question.details__additional_drivers input[type=radio]"),
			parent = details__additional_drivers.closest(".quote-question"),
			details__additional_drivers_confirm = parent.siblings(".details__additional_drivers_confirm"),
			details__additional_drivers_confirm_input = details__additional_drivers_confirm.find('input[type=checkbox]:not(.quote-tooltip__input)');
			
		// hide additional driver confirm question by default.
		details__additional_drivers_confirm.hide();
		details__additional_drivers_confirm_input.addClass('skip');

		// toggle inner question based on input change.
		details__additional_drivers.on("change", function () {
			if ($(this).val() == "true") {
				details__additional_drivers_confirm.show();
				details__additional_drivers_confirm_input.removeClass('skip');
			} else {
				details__additional_drivers_confirm.hide();
				details__additional_drivers_confirm_input.addClass('skip');
			}
		});

		// if the question was prefilled and has a value.
		if ($('input[name="' + details__additional_drivers.attr("name") + '"]:checked').val()) {
			if ($('input[name="' + details__additional_drivers.attr("name") + '"]:checked').val() == "true") {
				details__additional_drivers_confirm.show();
				details__additional_drivers_confirm_input.removeClass('skip');
			} else {
				details__additional_drivers_confirm.hide();
				details__additional_drivers_confirm_input.addClass('skip');
			}
		} else {
			details__additional_drivers_confirm.hide();
			details__additional_drivers_confirm_input.addClass('skip');
		}
	}
}

function toggleTabIndex() {
	$('.quote-question--children:not(.active)').each(function() {
		var currentEvent = $(this);

		currentEvent.children('.quote-question').find('input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="password"], button.quote-question__boolean-btn, a, select:not(.select2-hidden-accessible), textarea, .select2-selection, .c__info-tooltip').attr('tabindex', -1);

		currentEvent.find('select').on('select2:ready', function() {
			currentEvent.attr('tabindex', -1);
			currentEvent.next('.select2-container').find('.select2-selection').attr('tabindex', -1);
		});
	});
}

function toggleAdditionalDriverLockedQuestions() {
	if($(".quote-question.details__additional_drivers input[type=radio]").length) {
		// gather all variables needed.
		var details__additional_drivers = $(".quote-question.details__additional_drivers input[type=radio]"),
			parent = details__additional_drivers.closest(".quote-question").next(".quote-question--children-wrapper");

		// if the question was prefilled and has a value.
		if ($('input[name="' + details__additional_drivers.attr("name") + '"]:checked').val()) {
			if ($('input[name="' + details__additional_drivers.attr("name") + '"]:checked').val() == "false") {
				parent.find('.quote-question.readonly').each(function() {
					$(this).find('select[readonly], input[readonly]').removeAttr('readonly');
					$(this).find('.quote-question__boolean-btn.readonly').removeClass('readonly');
				});

				parent.find('.quote-question.readonly').removeClass('readonly');
			}
		} else {
			// details__additional_drivers_locked.hide();
		}

		addButtonEvents(parent);
	}
}

function toggleSelect2TabIndex() {
	setTimeout(function() {
		$(document).find('.select2[tabindex="-1"]').each(function() {
			$(this).find('.select2-selection').attr('tabindex', -1);
		});

		$(document).find('.quote-question--children:not(.active)').each(function() {
			var currentEvent = $(this);

			currentEvent.children('.quote-question').find('select.select2-hidden-accessible').next('.select2-container').find('.select2-selection').attr('tabindex', -1);
		});
	}, 500);
}

function toggleInputTabIndex() {
	$('.quote-question--children:not(.active)').each(function() {
		var currentEvent = $(this);

		currentEvent.children('.quote-question').find('input:not([data-tooltip="true"])').attr('tabindex', -1);
	});
}

function toggleAnchorTagClickAfterTab() {
	$(document).on('keydown', function(e) {
		if (e.key === 'Enter' || e.keyCode === 13) {
		  const $focused = $(document.activeElement);
		  if ($focused.is('a') || $focused.hasClass('c__info-tooltip') || $focused.attr('id') == 'car-incorrect-manual') {
			$focused.trigger('click');
		  }
		}
	  });
}

function recordPageNavigation() {
	// On every page
	let historyList = JSON.parse(localStorage.getItem('pageHistory')) || [];

	historyList.push({
		url: window.location.href,
		timestamp: new Date().toISOString()
	});

	localStorage.setItem('pageHistory', JSON.stringify(historyList));
}

function triggerConvictionBanHelpText() {
	$(document).on('change', 'input[name*="details__convictions_fine_ban"], input[name*="details__additional_convictions_ban"]', function() {
		if($(this).val() === "true" || $(this).val() === "yes") {
			$(this).closest('.quote-question').find('.quote-tooltip__content.helptext[data-activate-value="true"]').addClass('active');
		} else if($(this).val() === "false" || $(this).val() === "no") {
			$(this).closest('.quote-question').find('.quote-tooltip__content.helptext[data-activate-value="true"]').removeClass('active');
		}
	});
}

function select2TagSpanElements($root = $(document)) {
  $root.find('span').each(function () {
    const $span = $(this);
    if (this.id && !$span.is('[data-zuko-tag-name]')) {
      $span.attr('data-zuko-tag-name', 'button');
    }
  });
}

function setupSelect2Observers() {
	// Set up observer for dynamically added elements
	const observer = new MutationObserver(function (mutations) {
	mutations.forEach(function (mutation) {
		mutation.addedNodes.forEach(function (node) {
		if (node.nodeType === Node.ELEMENT_NODE) {
			const $node = $(node);
			if (node.tagName === 'SPAN') {
				select2TagSpanElements($node.parent());
			} else {
				select2TagSpanElements($node);
			}
		}
		});
	});
	});

	observer.observe(document.body, {
	childList: true,
	subtree: true
	});
}

function triggerLicenceNumberLookup() {
	if($('.license-number-none').length) {
        $(".license-number-none").on("change", function () {
			if (!$(this).prop("checked")) {
				calculateLicenceNumber($(this).closest(".quote-question"), true, "", true);
			}
		});
	}
}

$(function () {
	// make sure we only run our JS code within the correct template page.
	if ($(document).find(".collingwood-api").length) {
		// functionality to calculate the current scroll progress for the bar.
		$(window).on("scroll", calculateProgressBar);
		calculateProgressBar();

		// functionality to toggle the boolean questions yes/no.
		addButtonEvents($(".quote-question__wrapper"));

		// functionality to initialise select2 improved Dropdowns.
		addSelect2($(".quote-question__wrapper"));

		// functionality to initialise select2 dropdowns for Quote Results.
		addSelect2($(".quote__option-covers"));

		// Run on existing elements
		select2TagSpanElements();

		setupSelect2Observers();

		// functionality to initialise flatpickr for DatePicker.
		// addDatePicker($(".quote-question__wrapper"));

		// functionality to initialise flatpickr for Card Expiry Date.
		// addDatePicker($(".quote-question__expiry-date"));

		// functionality to initialise flatpickr for Quote Results Page.
		// addDatePicker($(".quote__option-period"));

		// functionality to toggle On/Off question sub children.
		toggleQuestionChildren($(".quote-question__wrapper"));

		// functionality to duplicate existing question groups.
		ajaxDuplicateQuestionGroups();

		// functionality to dynamically calculate someone's starting license number.
		calculateLicenceNumber($(".quote-question__wrapper > .quote-question:not(.quote-question__additional-driver)"));
		calculateLicenceNumber(
			$(".quote-question__wrapper > .quote-question.quote-question__additional-driver").next(".quote-question--children-wrapper").find(".quote-question--children .quote-question")
		);

		addBrowserDetails();

		resolveQueryPolicyButtons();

		submitQuoteResultsPage();

		triggerNewQuoteResults();

		addButtonPressedAnimation();

		resetQuoteCookie();

		buttonCorrectDetails();

		triggerCarOwnerQuestion();

		triggerOtherVehicleQuestion();

		triggerEmploymentQuestion();

		triggerMedicalConditionQuestion();

		triggerConvictionCodeQuestion();

		triggerAdditionalDriverEmploymentQuestion();

		triggerAdditionalDriverOtherVehicleQuestion();

		triggerAdditionalDriverConvictionCodeQuestion();

		triggerAdditionalDriverMedicalConditionQuestion();

		addonBreakdownSelection();

		inputToUppercase();

		triggerQuoteResultsTabs();

		triggerNewLicenseNumber();

		popupToggleScroll();

		checkDateInputs();

		aggregatorDetailsCorrect();

		aggregatorDeclarationDetailsCorrect();

		inputNumberKeyboard();

		triggerPaymentError();

		triggerAggregatorError();

		newCarRegClearQuestions();

		calculateTotalUKTime();

		additionalDriverCalculateTotalUKTime();

		triggerDefaultDatePicker();

		triggerQuoteGoBack();

		attachPolicyInformationDataAttributes();

		triggerNumberPreFormat();

		addDynamicDropdown();

		triggerImportantPolicyCheckboxes();

		ajaxValidateReferralCode();

		toggleAccountEditableFields();

		triggerLoadingOnSubmit();
		
		// submitQuoteStartForm();

		toggleAdditionalDriverConfirmQuestion();

		toggleAdditionalDriverLockedQuestions();

		toggleTabIndex();

		toggleSelect2TabIndex();

		toggleInputTabIndex();

		toggleAnchorTagClickAfterTab();

		recordPageNavigation();

		triggerConvictionBanHelpText();

		triggerLicenceNumberLookup();

		triggerMultiProductRequote();

		submitMultiProductPage();

		prefillDateInput();
	}
});

